/* eslint-disable */
// @ts-nocheck
/** ActivatePersonalPromotionStatus */
export var ActivatePersonalPromotionMessage;
(function (ActivatePersonalPromotionMessage) {
    /** Activation failed */
    ActivatePersonalPromotionMessage["ACTIVATION_FAILED"] = "ACTIVATION_FAILED";
    /** Activation not allowed */
    ActivatePersonalPromotionMessage["ACTIVATION_NOT_ALLOWED"] = "ACTIVATION_NOT_ALLOWED";
    /** Member id required */
    ActivatePersonalPromotionMessage["MEMBER_ID_REQUIRED"] = "MEMBER_ID_REQUIRED";
    /** Offer activated */
    ActivatePersonalPromotionMessage["OFFER_ACTIVATED"] = "OFFER_ACTIVATED";
})(ActivatePersonalPromotionMessage || (ActivatePersonalPromotionMessage = {}));
/** Additional status information that is returned from the service */
export var AddSmsReminderStatus;
(function (AddSmsReminderStatus) {
    /** Order not found */
    AddSmsReminderStatus["ORDER_NOT_FOUND"] = "ORDER_NOT_FOUND";
    /** Added */
    AddSmsReminderStatus["PHONE_NUMBER_ADDED"] = "PHONE_NUMBER_ADDED";
    /** Phone Number Invalid */
    AddSmsReminderStatus["PHONE_NUMBER_INVALID"] = "PHONE_NUMBER_INVALID";
})(AddSmsReminderStatus || (AddSmsReminderStatus = {}));
/** Type of the AdditionalReceiptItem */
export var AdditionalReceiptItemType;
(function (AdditionalReceiptItemType) {
    /** Deposit item */
    AdditionalReceiptItemType["DEPOSIT"] = "DEPOSIT";
    /** Deposit bags item */
    AdditionalReceiptItemType["DEPOSIT_BAGS"] = "DEPOSIT_BAGS";
    /** Deposit creates item */
    AdditionalReceiptItemType["DEPOSIT_CRATES"] = "DEPOSIT_CRATES";
    /** Deposit groceries item */
    AdditionalReceiptItemType["DEPOSIT_GROCERIES"] = "DEPOSIT_GROCERIES";
    /** Regular item */
    AdditionalReceiptItemType["ITEM"] = "ITEM";
    /** Nationale postcode loterij item */
    AdditionalReceiptItemType["NPL_VEGA"] = "NPL_VEGA";
    /** Purchase stamps item */
    AdditionalReceiptItemType["PURCHASE_STAMPS"] = "PURCHASE_STAMPS";
    /** Service memo item */
    AdditionalReceiptItemType["SERVICE_MEMO"] = "SERVICE_MEMO";
    /** Weight item */
    AdditionalReceiptItemType["WEIGHT"] = "WEIGHT";
})(AdditionalReceiptItemType || (AdditionalReceiptItemType = {}));
/** An advertisement's device type. This refers to the type of device that is used to render the advertisement on. */
export var AdvertisementDeviceType;
(function (AdvertisementDeviceType) {
    /** A desktop. */
    AdvertisementDeviceType["DESKTOP"] = "DESKTOP";
    /** A phone. */
    AdvertisementDeviceType["PHONE"] = "PHONE";
    /** A tablet. */
    AdvertisementDeviceType["TABLET"] = "TABLET";
})(AdvertisementDeviceType || (AdvertisementDeviceType = {}));
/** Enum for the basket shopping type eg: "DELIVERY", "DELIVERY_POINT" */
export var BasketShoppingType;
(function (BasketShoppingType) {
    /** Home delivery */
    BasketShoppingType["DELIVERY"] = "DELIVERY";
    /** Special pickup point for AH employees */
    BasketShoppingType["DELIVERY_POINT"] = "DELIVERY_POINT";
    /** Like a normal pickup but assortment is limited to what is available in the store */
    BasketShoppingType["IN_STORE_PICK"] = "IN_STORE_PICK";
    /** When user is not in order mode and the basket is sorted by walking route */
    BasketShoppingType["PHYSICAL_STORE"] = "PHYSICAL_STORE";
    /** Deliver products to a pickup location */
    BasketShoppingType["PICKUP"] = "PICKUP";
    /** Special business type of delivery */
    BasketShoppingType["PICKUP_DELIVERY"] = "PICKUP_DELIVERY";
    /** When user wants to pickup the (special) products in a store. */
    BasketShoppingType["SPECIALS_ONLY"] = "SPECIALS_ONLY";
    /** When user did not select shopping type yet */
    BasketShoppingType["UNKNOWN"] = "UNKNOWN";
})(BasketShoppingType || (BasketShoppingType = {}));
/** Bonus filter types. When passed it allows to filter products that have bonus price of specified type */
export var BonusFilterType;
(function (BonusFilterType) {
    /** All bonus types */
    BonusFilterType["ALL"] = "ALL";
    /** Etos bonus type */
    BonusFilterType["ETOS"] = "ETOS";
    /** Mass bonus type */
    BonusFilterType["MASS"] = "MASS";
    /** Default filter */
    BonusFilterType["NONE"] = "NONE";
    /** Personal bonus type */
    BonusFilterType["PERSONAL"] = "PERSONAL";
    /** Spotlight bonus type */
    BonusFilterType["SPOTLIGHT"] = "SPOTLIGHT";
    /** Store bonus type */
    BonusFilterType["STORE"] = "STORE";
})(BonusFilterType || (BonusFilterType = {}));
/** Bonus Lane type that can be free delivery or personal bonus */
export var BonusLaneType;
(function (BonusLaneType) {
    BonusLaneType["FREE_DELIVERY"] = "FREE_DELIVERY";
    BonusLaneType["PERSONAL"] = "PERSONAL";
})(BonusLaneType || (BonusLaneType = {}));
/** Promotion type */
export var BonusPromotionType;
(function (BonusPromotionType) {
    /** Ah Online */
    BonusPromotionType["AHONLINE"] = "AHONLINE";
    /** ETOS */
    BonusPromotionType["ETOS"] = "ETOS";
    /** GALL */
    BonusPromotionType["GALL"] = "GALL";
    /** GALLCARD */
    BonusPromotionType["GALLCARD"] = "GALLCARD";
    /** Usually free delivery */
    BonusPromotionType["INCENTIVE"] = "INCENTIVE";
    /** National */
    BonusPromotionType["NATIONAL"] = "NATIONAL";
    /** Personal */
    BonusPromotionType["PERSONAL"] = "PERSONAL";
    /**
     * Previously bought
     * @deprecated Removed from the bonus segment
     */
    BonusPromotionType["PREVIOUSLY_BOUGHT"] = "PREVIOUSLY_BOUGHT";
    /**
     * Spotlight
     * @deprecated Replaced by the spotlight argument on the query bonusSegments
     */
    BonusPromotionType["SPOTLIGHT"] = "SPOTLIGHT";
})(BonusPromotionType || (BonusPromotionType = {}));
/** Activation statuses for segment */
export var BonusSegmentActivationStatus;
(function (BonusSegmentActivationStatus) {
    /** ACTIVATABLE */
    BonusSegmentActivationStatus["ACTIVATABLE"] = "ACTIVATABLE";
    /** ACTIVATED */
    BonusSegmentActivationStatus["ACTIVATED"] = "ACTIVATED";
    /** ASSIGNED */
    BonusSegmentActivationStatus["ASSIGNED"] = "ASSIGNED";
    /** NONE */
    BonusSegmentActivationStatus["NONE"] = "NONE";
    /** REDEEMABLE */
    BonusSegmentActivationStatus["REDEEMABLE"] = "REDEEMABLE";
    /** REDEEMED */
    BonusSegmentActivationStatus["REDEEMED"] = "REDEEMED";
})(BonusSegmentActivationStatus || (BonusSegmentActivationStatus = {}));
/** BonusSegmentDiscountLabelCodes */
export var BonusSegmentDiscountLabelCodes;
(function (BonusSegmentDiscountLabelCodes) {
    /** ACTION */
    BonusSegmentDiscountLabelCodes["ACTION"] = "ACTION";
    /** AIRMILES */
    BonusSegmentDiscountLabelCodes["AIRMILES"] = "AIRMILES";
    /** AMOUNT */
    BonusSegmentDiscountLabelCodes["AMOUNT"] = "AMOUNT";
    /** ARTICLE PERCENTAGE */
    BonusSegmentDiscountLabelCodes["ARTICLE_PERCENTAGE"] = "ARTICLE_PERCENTAGE";
    /** BONUS */
    BonusSegmentDiscountLabelCodes["BONUS"] = "BONUS";
    /** BUNDLE */
    BonusSegmentDiscountLabelCodes["BUNDLE"] = "BUNDLE";
    /** BUNDLE_BULK */
    BonusSegmentDiscountLabelCodes["BUNDLE_BULK"] = "BUNDLE_BULK";
    /** BUNDLE_MIXED */
    BonusSegmentDiscountLabelCodes["BUNDLE_MIXED"] = "BUNDLE_MIXED";
    /** DELIVERY INCENTIVE */
    BonusSegmentDiscountLabelCodes["DELIVERY_INCENTIVE"] = "DELIVERY_INCENTIVE";
    /** FALLBACK */
    BonusSegmentDiscountLabelCodes["FALLBACK"] = "FALLBACK";
    /** FIXED PRICE */
    BonusSegmentDiscountLabelCodes["FIXED_PRICE"] = "FIXED_PRICE";
    /** FREE DELIVERY */
    BonusSegmentDiscountLabelCodes["FREE_DELIVERY"] = "FREE_DELIVERY";
    /** FREE DELIVERY AMOUNT */
    BonusSegmentDiscountLabelCodes["FREE_DELIVERY_AMOUNT"] = "FREE_DELIVERY_AMOUNT";
    /** N PAID */
    BonusSegmentDiscountLabelCodes["N_PAID"] = "N_PAID";
    /** ONE FREE */
    BonusSegmentDiscountLabelCodes["ONE_FREE"] = "ONE_FREE";
    /** ONE HALF PRICE */
    BonusSegmentDiscountLabelCodes["ONE_HALF_PRICE"] = "ONE_HALF_PRICE";
    /** PERCENTANGE */
    BonusSegmentDiscountLabelCodes["PERCENTAGE"] = "PERCENTAGE";
    /** PERCENTAGE PER AMOUNT */
    BonusSegmentDiscountLabelCodes["PERCENTAGE_PER_AMOUNT"] = "PERCENTAGE_PER_AMOUNT";
    /** ROUTE99 */
    BonusSegmentDiscountLabelCodes["ROUTE99"] = "ROUTE99";
    /** SCRATCH_CARD */
    BonusSegmentDiscountLabelCodes["SCRATCH_CARD"] = "SCRATCH_CARD";
    /** TIERED PERCENT */
    BonusSegmentDiscountLabelCodes["TIERED_PERCENT"] = "TIERED_PERCENT";
    /** TIERED PRICE */
    BonusSegmentDiscountLabelCodes["TIERED_PRICE"] = "TIERED_PRICE";
    /** UNIT FIXED PRICE */
    BonusSegmentDiscountLabelCodes["UNIT_FIXED_PRICE"] = "UNIT_FIXED_PRICE";
    /** VIRTUAL BUNDLE */
    BonusSegmentDiscountLabelCodes["VIRTUAL_BUNDLE"] = "VIRTUAL_BUNDLE";
    /** WEIGHT */
    BonusSegmentDiscountLabelCodes["WEIGHT"] = "WEIGHT";
    /** X FOR Y */
    BonusSegmentDiscountLabelCodes["X_FOR_Y"] = "X_FOR_Y";
    /** X PLUS Y FREE */
    BonusSegmentDiscountLabelCodes["X_PLUS_Y_FREE"] = "X_PLUS_Y_FREE";
    /** X WITH REDUCTION */
    BonusSegmentDiscountLabelCodes["X_WITH_REDUCTION"] = "X_WITH_REDUCTION";
})(BonusSegmentDiscountLabelCodes || (BonusSegmentDiscountLabelCodes = {}));
/** BonusSegmentDiscountShieldEmphasis */
export var BonusSegmentDiscountShieldEmphasis;
(function (BonusSegmentDiscountShieldEmphasis) {
    /** bottom */
    BonusSegmentDiscountShieldEmphasis["BOTTOM"] = "BOTTOM";
    /** default */
    BonusSegmentDiscountShieldEmphasis["DEFAULT"] = "DEFAULT";
    /** middle */
    BonusSegmentDiscountShieldEmphasis["MIDDLE"] = "MIDDLE";
    /** top */
    BonusSegmentDiscountShieldEmphasis["TOP"] = "TOP";
})(BonusSegmentDiscountShieldEmphasis || (BonusSegmentDiscountShieldEmphasis = {}));
/** BonusSegmentDiscountShieldTheme */
export var BonusSegmentDiscountShieldTheme;
(function (BonusSegmentDiscountShieldTheme) {
    /** Airmiles */
    BonusSegmentDiscountShieldTheme["AIRMILES"] = "AIRMILES";
    /** Bonus */
    BonusSegmentDiscountShieldTheme["BONUS"] = "BONUS";
    /** Bonus Box */
    BonusSegmentDiscountShieldTheme["BONUS_BOX"] = "BONUS_BOX";
    /** Bundle */
    BonusSegmentDiscountShieldTheme["BUNDLE"] = "BUNDLE";
    /** Etos */
    BonusSegmentDiscountShieldTheme["ETOS"] = "ETOS";
    /** Gall */
    BonusSegmentDiscountShieldTheme["GALL"] = "GALL";
    /** Infinite */
    BonusSegmentDiscountShieldTheme["INFINITE"] = "INFINITE";
    /** Premium */
    BonusSegmentDiscountShieldTheme["PREMIUM"] = "PREMIUM";
    /** Spotlight */
    BonusSegmentDiscountShieldTheme["SPOTLIGHT"] = "SPOTLIGHT";
    /** Tiered offers */
    BonusSegmentDiscountShieldTheme["TIERED_OFFERS"] = "TIERED_OFFERS";
})(BonusSegmentDiscountShieldTheme || (BonusSegmentDiscountShieldTheme = {}));
/** BonusSegmentState contains the states possible for a bonus segment */
export var BonusSegmentState;
(function (BonusSegmentState) {
    /** Bonus box promotions that can be activated by the user */
    BonusSegmentState["ACTIVATABLE"] = "ACTIVATABLE";
    /** Bonus box promotions that have been activated */
    BonusSegmentState["ACTIVATED"] = "ACTIVATED";
    /** Personal promotions assigned to the user */
    BonusSegmentState["ASSIGNED"] = "ASSIGNED";
    /** Exclude bonus box promotions that can be activated by the user */
    BonusSegmentState["NEGATE_ACTIVATABLE"] = "NEGATE_ACTIVATABLE";
    /** Exclude bonus box promotions that have been activated */
    BonusSegmentState["NEGATE_ACTIVATED"] = "NEGATE_ACTIVATED";
    /** Exclude personal promotions assigned to the user */
    BonusSegmentState["NEGATE_ASSIGNED"] = "NEGATE_ASSIGNED";
    /** NEGATE_NONE */
    BonusSegmentState["NEGATE_NONE"] = "NEGATE_NONE";
    /** Exclude digital scratch card promotions that can be redeemed at checkout */
    BonusSegmentState["NEGATE_REDEEMABLE"] = "NEGATE_REDEEMABLE";
    /** Exclude digital scratch card promotions that have been redeemed (i.e. the user has already bought and received the product) */
    BonusSegmentState["NEGATE_REDEEMED"] = "NEGATE_REDEEMED";
    /** NONE */
    BonusSegmentState["NONE"] = "NONE";
    /** Digital scratch card promotions that can be redeemed at checkout */
    BonusSegmentState["REDEEMABLE"] = "REDEEMABLE";
    /** Digital scratch card promotions that have been redeemed (i.e. the user has already bought and received the product) */
    BonusSegmentState["REDEEMED"] = "REDEEMED";
})(BonusSegmentState || (BonusSegmentState = {}));
/** BonusSegmentType */
export var BonusSegmentType;
(function (BonusSegmentType) {
    /** AH stores */
    BonusSegmentType["AH"] = "AH";
    /** AH online only */
    BonusSegmentType["AH_ONLINE_ONLY"] = "AH_ONLINE_ONLY";
    /** AH online only subtype */
    BonusSegmentType["AH_ONLINE_ONLY_SUBTYPE"] = "AH_ONLINE_ONLY_SUBTYPE";
    /** AH XL */
    BonusSegmentType["AH_XL"] = "AH_XL";
    /** Bonus box */
    BonusSegmentType["BONUS_BOX"] = "BONUS_BOX";
    /** BUNDEL */
    BonusSegmentType["BUNDEL"] = "BUNDEL";
    /** Delivery bundle */
    BonusSegmentType["DELIVERY_BUNDLE"] = "DELIVERY_BUNDLE";
    /** DIGITAL_SCRATCH_CARD */
    BonusSegmentType["DIGITAL_SCRATCH_CARD"] = "DIGITAL_SCRATCH_CARD";
    /** Etos */
    BonusSegmentType["ETOS"] = "ETOS";
    /** Free delivery */
    BonusSegmentType["FREE_DELIVERY"] = "FREE_DELIVERY";
    /** Gall customer card and online */
    BonusSegmentType["GALL_CUSTOMER_CARD"] = "GALL_CUSTOMER_CARD";
    /** Gall online only */
    BonusSegmentType["GALL_ONLINE_ONLY"] = "GALL_ONLINE_ONLY";
    /** NEGATE_DIGITAL_SCRATCH_CARD */
    BonusSegmentType["NEGATE_DIGITAL_SCRATCH_CARD"] = "NEGATE_DIGITAL_SCRATCH_CARD";
    /** NEGATE_PREMIUM */
    BonusSegmentType["NEGATE_PREMIUM"] = "NEGATE_PREMIUM";
    /** Personal */
    BonusSegmentType["PERSONAL_BONUS"] = "PERSONAL_BONUS";
    /** Premium */
    BonusSegmentType["PREMIUM"] = "PREMIUM";
})(BonusSegmentType || (BonusSegmentType = {}));
/** Bonus Themes */
export var BonusTheme;
(function (BonusTheme) {
    /** Regular bonus */
    BonusTheme["BONUS"] = "BONUS";
    /** Personal bonus */
    BonusTheme["BONUS_BOX"] = "BONUS_BOX";
    /** Etos */
    BonusTheme["ETOS"] = "ETOS";
    /** Gall'n'Gall */
    BonusTheme["GALL"] = "GALL";
    /** Infinite */
    BonusTheme["INFINITE"] = "INFINITE";
    /** Premium */
    BonusTheme["PREMIUM"] = "PREMIUM";
    /** Tiered offer */
    BonusTheme["TIERED_OFFER"] = "TIERED_OFFER";
})(BonusTheme || (BonusTheme = {}));
/** Period of a budget */
export var BudgetPeriod;
(function (BudgetPeriod) {
    /** Period of a month */
    BudgetPeriod["MONTH"] = "MONTH";
    /** No period */
    BudgetPeriod["NONE"] = "NONE";
    /** Period of a year */
    BudgetPeriod["YEAR"] = "YEAR";
})(BudgetPeriod || (BudgetPeriod = {}));
export var BudgetType;
(function (BudgetType) {
    /** Monthly budget. */
    BudgetType["MONTHLY"] = "MONTHLY";
    /** Yearly budget. */
    BudgetType["YEARLY"] = "YEARLY";
})(BudgetType || (BudgetType = {}));
/** ButtonType */
export var ButtonType;
(function (ButtonType) {
    ButtonType["LOGIN"] = "LOGIN";
    ButtonType["PRIMARY"] = "PRIMARY";
    ButtonType["SECONDARY"] = "SECONDARY";
})(ButtonType || (ButtonType = {}));
/** cache control */
export var CacheControlScope;
(function (CacheControlScope) {
    /** Personal data, based on jwt token and locale (see server.ts) */
    CacheControlScope["PRIVATE"] = "PRIVATE";
    /** Public data, non personal */
    CacheControlScope["PUBLIC"] = "PUBLIC";
})(CacheControlScope || (CacheControlScope = {}));
export var ChallengeType;
(function (ChallengeType) {
    /** Device */
    ChallengeType["DEVICE"] = "DEVICE";
    /** User */
    ChallengeType["USER"] = "USER";
})(ChallengeType || (ChallengeType = {}));
export var Channel;
(function (Channel) {
    /** ANDROID */
    Channel["ANDROID"] = "ANDROID";
    /** APPLICATION */
    Channel["APPLICATION"] = "APPLICATION";
    /** IOS */
    Channel["IOS"] = "IOS";
    /** WEB */
    Channel["WEB"] = "WEB";
})(Channel || (Channel = {}));
/** Customer care channel availability status */
export var ChannelAvailabilityStatus;
(function (ChannelAvailabilityStatus) {
    /** Channel status available */
    ChannelAvailabilityStatus["AVAILABLE"] = "AVAILABLE";
    /** Channel status unavailable */
    ChannelAvailabilityStatus["UNAVAILABLE"] = "UNAVAILABLE";
})(ChannelAvailabilityStatus || (ChannelAvailabilityStatus = {}));
/** Customer care channels supported platforms */
export var ChannelPlatform;
(function (ChannelPlatform) {
    /** Platform appie app */
    ChannelPlatform["AH_APP"] = "AH_APP";
    /** Platform Food First Network */
    ChannelPlatform["FFN_APP"] = "FFN_APP";
    /** Platform web */
    ChannelPlatform["WEB"] = "WEB";
})(ChannelPlatform || (ChannelPlatform = {}));
/** Customer care channel type */
export var ChannelType;
(function (ChannelType) {
    /** Channel chat */
    ChannelType["CHAT"] = "CHAT";
    /** Channel phone */
    ChannelType["PHONE"] = "PHONE";
})(ChannelType || (ChannelType = {}));
/** Limits you can hit on the checkout */
export var CheckoutAtpLimitType;
(function (CheckoutAtpLimitType) {
    /** Limit on ordering products. for example: Beer and Nutrilon */
    CheckoutAtpLimitType["ORDER_LIMIT"] = "ORDER_LIMIT";
    /** Maximum stock available */
    CheckoutAtpLimitType["STOCK_LIMIT"] = "STOCK_LIMIT";
})(CheckoutAtpLimitType || (CheckoutAtpLimitType = {}));
/** CheckoutErrors Enum, DCT errors and Possible validation errors combined. */
export var CheckoutErrors;
(function (CheckoutErrors) {
    /** DCT Card Limit is reached */
    CheckoutErrors["CARD_LIMIT_REACHED"] = "CARD_LIMIT_REACHED";
    /** DCT Card is not active */
    CheckoutErrors["CARD_NOT_ACTIVE"] = "CARD_NOT_ACTIVE";
    /** Customer not found */
    CheckoutErrors["CUSTOMER_NOT_FOUND"] = "CUSTOMER_NOT_FOUND";
    /** Delivery not found */
    CheckoutErrors["DELIVERY_NOT_FOUND"] = "DELIVERY_NOT_FOUND";
    /** Illegal order state */
    CheckoutErrors["ILLEGAL_ORDER_STATE"] = "ILLEGAL_ORDER_STATE";
    /** Illegal Order Type */
    CheckoutErrors["ILLEGAL_ORDER_TYPE"] = "ILLEGAL_ORDER_TYPE";
    /** DCT Card is on low funds */
    CheckoutErrors["LOW_FUNDS"] = "LOW_FUNDS";
    /** Member account Blocked */
    CheckoutErrors["MEMBER_BLOCKED"] = "MEMBER_BLOCKED";
    /** Member Error Type */
    CheckoutErrors["MEMBER_ERROR"] = "MEMBER_ERROR";
    /** Member Not Authenticated */
    CheckoutErrors["MEMBER_NOT_AUTHENTICATED"] = "MEMBER_NOT_AUTHENTICATED";
    /** Member not allowed to read order. */
    CheckoutErrors["MEMBER_NOT_AUTHORIZED"] = "MEMBER_NOT_AUTHORIZED";
    /** Missing Membership */
    CheckoutErrors["MISSING_MEMBERSHIP"] = "MISSING_MEMBERSHIP";
    /** Order ATP Check Failed */
    CheckoutErrors["ORDER_ATP_FAILED"] = "ORDER_ATP_FAILED";
    /** Order externally modified */
    CheckoutErrors["ORDER_EXTERNALLY_MODIFIED"] = "ORDER_EXTERNALLY_MODIFIED";
    /** Order Maximum amount type */
    CheckoutErrors["ORDER_MAXIMUM_AMOUNT_TYPE"] = "ORDER_MAXIMUM_AMOUNT_TYPE";
    /** Order minimum amount value, The order price is below the minimum amount value */
    CheckoutErrors["ORDER_MINIMUM_AMOUNT_TYPE"] = "ORDER_MINIMUM_AMOUNT_TYPE";
    /** OrderNotFound */
    CheckoutErrors["ORDER_NOT_FOUND"] = "ORDER_NOT_FOUND";
    /** DCT Card Reservation Adjustment failed */
    CheckoutErrors["RESERVATION_ADJUSTMENT_FAILED"] = "RESERVATION_ADJUSTMENT_FAILED";
    /** Card is Restricted */
    CheckoutErrors["RESTRICTED_CARD"] = "RESTRICTED_CARD";
    /** Restricted item check amount failed */
    CheckoutErrors["RESTRICTED_ITEM_CHECK_AMOUNT_FAILED"] = "RESTRICTED_ITEM_CHECK_AMOUNT_FAILED";
    /** Restricted Item Check Failed */
    CheckoutErrors["RESTRICTED_ITEM_CHECK_FAILED"] = "RESTRICTED_ITEM_CHECK_FAILED";
    /** Unknown error */
    CheckoutErrors["UNKNOWN"] = "UNKNOWN";
})(CheckoutErrors || (CheckoutErrors = {}));
/** Error codes for mutation.ciamDeleteAccount */
export var CiamDeleteAccountMutationResultErrorCode;
(function (CiamDeleteAccountMutationResultErrorCode) {
    /** The provided current password is incorrect. */
    CiamDeleteAccountMutationResultErrorCode["OLD_PASSWORD_INCORRECT"] = "OLD_PASSWORD_INCORRECT";
})(CiamDeleteAccountMutationResultErrorCode || (CiamDeleteAccountMutationResultErrorCode = {}));
/** Error codes for mutation.ciamPasswordChange */
export var CiamPasswordChangeMutationResultErrorCode;
(function (CiamPasswordChangeMutationResultErrorCode) {
    /** Password not allowed (too short, leaked, etc.). */
    CiamPasswordChangeMutationResultErrorCode["NEW_PASSWORD_NOT_ALLOWED"] = "NEW_PASSWORD_NOT_ALLOWED";
    /** The provided current password is incorrect. */
    CiamPasswordChangeMutationResultErrorCode["OLD_PASSWORD_INCORRECT"] = "OLD_PASSWORD_INCORRECT";
})(CiamPasswordChangeMutationResultErrorCode || (CiamPasswordChangeMutationResultErrorCode = {}));
/** Possible error codes for `Mutation.ciamPhoneNumberVerifyCode` */
export var CiamPhoneNumberVerifyCodeErrorCode;
(function (CiamPhoneNumberVerifyCodeErrorCode) {
    /** Member ID does not exist */
    CiamPhoneNumberVerifyCodeErrorCode["MEMBER_NOT_FOUND"] = "MEMBER_NOT_FOUND";
    /** Session ID not found */
    CiamPhoneNumberVerifyCodeErrorCode["VERIFICATION_NOT_FOUND"] = "VERIFICATION_NOT_FOUND";
    /** Wrong code was used */
    CiamPhoneNumberVerifyCodeErrorCode["WRONG_CODE"] = "WRONG_CODE";
    /** Wrong code, session deleted, need to start over */
    CiamPhoneNumberVerifyCodeErrorCode["WRONG_CODE_LAST_ATTEMPT"] = "WRONG_CODE_LAST_ATTEMPT";
    /** Not your own data */
    CiamPhoneNumberVerifyCodeErrorCode["WRONG_MEMBER"] = "WRONG_MEMBER";
})(CiamPhoneNumberVerifyCodeErrorCode || (CiamPhoneNumberVerifyCodeErrorCode = {}));
/** Error codes for mutation.ciamUsernameChange */
export var CiamUserNameChangeMutationResultErrorCode;
(function (CiamUserNameChangeMutationResultErrorCode) {
    /** Username not allowed (not an email address, already in use?). */
    CiamUserNameChangeMutationResultErrorCode["NEW_USERNAME_NOT_ALLOWED"] = "NEW_USERNAME_NOT_ALLOWED";
    /** The provided current password is incorrect. */
    CiamUserNameChangeMutationResultErrorCode["OLD_PASSWORD_INCORRECT"] = "OLD_PASSWORD_INCORRECT";
})(CiamUserNameChangeMutationResultErrorCode || (CiamUserNameChangeMutationResultErrorCode = {}));
/** CMS mode enum */
export var CmsMode;
(function (CmsMode) {
    /** the cms content for our customers on ah.* */
    CmsMode["DEFAULT"] = "DEFAULT";
    /** the cms content for external preview e.g. preview.ah.* */
    CmsMode["EXTERNAL_PREVIEW"] = "EXTERNAL_PREVIEW";
    /** the cms content for preview in CMS Experience Manager */
    CmsMode["PREVIEW"] = "PREVIEW";
})(CmsMode || (CmsMode = {}));
/** The status of the code */
export var CodeStatus;
(function (CodeStatus) {
    /** Password reset code is invalid */
    CodeStatus["INVALID"] = "INVALID";
    /** Password reset code is valid */
    CodeStatus["VALID"] = "VALID";
})(CodeStatus || (CodeStatus = {}));
/** Types of recipes that can be saved in categories */
export var CollectionCategoryRecipeType;
(function (CollectionCategoryRecipeType) {
    /** Allerhande */
    CollectionCategoryRecipeType["A"] = "A";
    /** Others */
    CollectionCategoryRecipeType["O"] = "O";
})(CollectionCategoryRecipeType || (CollectionCategoryRecipeType = {}));
/** Enum representing communication consent channel */
export var CommunicationConsentChannel;
(function (CommunicationConsentChannel) {
    /** Email channel */
    CommunicationConsentChannel["EMAIL"] = "EMAIL";
    /** Push channel */
    CommunicationConsentChannel["PUSH"] = "PUSH";
})(CommunicationConsentChannel || (CommunicationConsentChannel = {}));
/** Accordion block types */
export var ContentAccordionBlockType;
(function (ContentAccordionBlockType) {
    ContentAccordionBlockType["BUTTONS"] = "BUTTONS";
    ContentAccordionBlockType["MEDIA"] = "MEDIA";
    ContentAccordionBlockType["PARAGRAPH"] = "PARAGRAPH";
    ContentAccordionBlockType["QUOTE"] = "QUOTE";
    ContentAccordionBlockType["TABLE"] = "TABLE";
})(ContentAccordionBlockType || (ContentAccordionBlockType = {}));
/** Type of Accordion (Manual/Search) */
export var ContentAccordionType;
(function (ContentAccordionType) {
    ContentAccordionType["MANUAL"] = "MANUAL";
    ContentAccordionType["SEARCH"] = "SEARCH";
})(ContentAccordionType || (ContentAccordionType = {}));
/** Content Spotlight Item Type */
export var ContentAllerhandeSpotlightType;
(function (ContentAllerhandeSpotlightType) {
    ContentAllerhandeSpotlightType["RECIPE"] = "RECIPE";
    ContentAllerhandeSpotlightType["VIDEO_BLUE_BILLYWIG"] = "VIDEO_BLUE_BILLYWIG";
})(ContentAllerhandeSpotlightType || (ContentAllerhandeSpotlightType = {}));
/** Article content blocks types */
export var ContentArticleBlockType;
(function (ContentArticleBlockType) {
    ContentArticleBlockType["BUTTONS"] = "BUTTONS";
    ContentArticleBlockType["MEDIA"] = "MEDIA";
    ContentArticleBlockType["PARAGRAPH"] = "PARAGRAPH";
    ContentArticleBlockType["QUOTE"] = "QUOTE";
    ContentArticleBlockType["TABLE"] = "TABLE";
})(ContentArticleBlockType || (ContentArticleBlockType = {}));
/** CMS mobile types */
export var ContentBaseMobileCmsComponentType;
(function (ContentBaseMobileCmsComponentType) {
    ContentBaseMobileCmsComponentType["ARTICLE_DOCUMENT"] = "ARTICLE_DOCUMENT";
    ContentBaseMobileCmsComponentType["OVERBLIJVERS_BOXES_DOCUMENT"] = "OVERBLIJVERS_BOXES_DOCUMENT";
    /** @deprecated Enum value doesn't follow codestyle, use PAGE_ENTRIES instead */
    ContentBaseMobileCmsComponentType["PAGEENTRIES"] = "PAGEENTRIES";
    ContentBaseMobileCmsComponentType["PAGE_ENTRIES"] = "PAGE_ENTRIES";
    /** @deprecated Enum value doesn't follow codestyle, use PROPOSITION_HEADER instead */
    ContentBaseMobileCmsComponentType["PROPOSITIONHEADER"] = "PROPOSITIONHEADER";
    ContentBaseMobileCmsComponentType["PROPOSITION_HEADER"] = "PROPOSITION_HEADER";
})(ContentBaseMobileCmsComponentType || (ContentBaseMobileCmsComponentType = {}));
/** CMS targeted content document types */
export var ContentBaseTargetedContentCmsDocumentType;
(function (ContentBaseTargetedContentCmsDocumentType) {
    ContentBaseTargetedContentCmsDocumentType["CURATED_LISTS"] = "CURATED_LISTS";
    ContentBaseTargetedContentCmsDocumentType["MOBILE_PAGE_TEMPLATE"] = "MOBILE_PAGE_TEMPLATE";
    ContentBaseTargetedContentCmsDocumentType["PAGE_ENTRIES"] = "PAGE_ENTRIES";
    ContentBaseTargetedContentCmsDocumentType["PROPOSITION_HEADER"] = "PROPOSITION_HEADER";
    ContentBaseTargetedContentCmsDocumentType["SPOTLIGHT_LIST"] = "SPOTLIGHT_LIST";
})(ContentBaseTargetedContentCmsDocumentType || (ContentBaseTargetedContentCmsDocumentType = {}));
/** CMS Component Render Status */
export var ContentCmsComponentStatus;
(function (ContentCmsComponentStatus) {
    ContentCmsComponentStatus["COMPLETE"] = "COMPLETE";
    ContentCmsComponentStatus["INCOMPLETE"] = "INCOMPLETE";
})(ContentCmsComponentStatus || (ContentCmsComponentStatus = {}));
/** CMS Component Types */
export var ContentCmsComponentType;
(function (ContentCmsComponentType) {
    ContentCmsComponentType["ACCORDION"] = "ACCORDION";
    ContentCmsComponentType["ADVERTORIAL"] = "ADVERTORIAL";
    ContentCmsComponentType["AHRMS_SPOTLIGHT_LIST"] = "AHRMS_SPOTLIGHT_LIST";
    ContentCmsComponentType["ALLERHANDE_CONTENT_LIST_LANE"] = "ALLERHANDE_CONTENT_LIST_LANE";
    ContentCmsComponentType["ALLERHANDE_FAQ_LANE"] = "ALLERHANDE_FAQ_LANE";
    ContentCmsComponentType["ALLERHANDE_HIGHLIGHTED_THEMES_LANE"] = "ALLERHANDE_HIGHLIGHTED_THEMES_LANE";
    ContentCmsComponentType["ALLERHANDE_IMAGE_COLLECTION_LANE"] = "ALLERHANDE_IMAGE_COLLECTION_LANE";
    ContentCmsComponentType["ALLERHANDE_RECIPE_DETAIL_LANE"] = "ALLERHANDE_RECIPE_DETAIL_LANE";
    ContentCmsComponentType["ALLERHANDE_RECIPE_GRID_LANE"] = "ALLERHANDE_RECIPE_GRID_LANE";
    ContentCmsComponentType["ALLERHANDE_RECIPE_GROUP_HEADER_LANE"] = "ALLERHANDE_RECIPE_GROUP_HEADER_LANE";
    ContentCmsComponentType["ALLERHANDE_RECIPE_SEARCH_BANNER"] = "ALLERHANDE_RECIPE_SEARCH_BANNER";
    ContentCmsComponentType["ALLERHANDE_SPOTLIGHT"] = "ALLERHANDE_SPOTLIGHT";
    ContentCmsComponentType["ALLERHANDE_TEXT_IMAGE_ITEMS_CONTENT_LANE"] = "ALLERHANDE_TEXT_IMAGE_ITEMS_CONTENT_LANE";
    ContentCmsComponentType["ALLERHANDE_THEME_LIST_CARD_COLLECTION_LANE"] = "ALLERHANDE_THEME_LIST_CARD_COLLECTION_LANE";
    ContentCmsComponentType["ALLERHANDE_VIDEO_LANE"] = "ALLERHANDE_VIDEO_LANE";
    ContentCmsComponentType["ALLERHANDE_WEEKMENU"] = "ALLERHANDE_WEEKMENU";
    ContentCmsComponentType["ARTICLE"] = "ARTICLE";
    ContentCmsComponentType["BONUS_LANE"] = "BONUS_LANE";
    /** @deprecated Enum value doesn't follow codestyle, use BRAND_HEADER instead */
    ContentCmsComponentType["BRANDHEADER"] = "BRANDHEADER";
    ContentCmsComponentType["BRAND_HEADER"] = "BRAND_HEADER";
    /** @deprecated Enum value doesn't follow codestyle, use BUTTON_LANE instead */
    ContentCmsComponentType["BUTTONLANE"] = "BUTTONLANE";
    ContentCmsComponentType["BUTTON_LANE"] = "BUTTON_LANE";
    ContentCmsComponentType["CURATED_LIST_LANE"] = "CURATED_LIST_LANE";
    ContentCmsComponentType["CUSTOMER_CARE_ARTICLE"] = "CUSTOMER_CARE_ARTICLE";
    ContentCmsComponentType["CUSTOMER_CARE_BREADCRUMBS"] = "CUSTOMER_CARE_BREADCRUMBS";
    ContentCmsComponentType["CUSTOMER_CARE_HEADER"] = "CUSTOMER_CARE_HEADER";
    ContentCmsComponentType["CUSTOMER_CARE_LINK_BOX_LANE"] = "CUSTOMER_CARE_LINK_BOX_LANE";
    ContentCmsComponentType["CUSTOMER_CARE_LINK_LANE"] = "CUSTOMER_CARE_LINK_LANE";
    ContentCmsComponentType["FORM"] = "FORM";
    ContentCmsComponentType["GRID_LANE"] = "GRID_LANE";
    /** @deprecated Enum value doesn't follow codestyle, use HALF_WIDTH_MEDIA_MONETIZATION_LANE instead */
    ContentCmsComponentType["HALFWIDTHMEDIAMONETIZATIONLANE"] = "HALFWIDTHMEDIAMONETIZATIONLANE";
    ContentCmsComponentType["HALF_WIDTH_MEDIA_MONETIZATION_LANE"] = "HALF_WIDTH_MEDIA_MONETIZATION_LANE";
    /** @deprecated Enum value doesn't follow codestyle, use HERO_BANNER instead */
    ContentCmsComponentType["HEROBANNER"] = "HEROBANNER";
    ContentCmsComponentType["HERO_BANNER"] = "HERO_BANNER";
    /** @deprecated Enum value doesn't follow codestyle, use LINK_GROUP instead */
    ContentCmsComponentType["LINKGROUP"] = "LINKGROUP";
    ContentCmsComponentType["LINK_GROUP"] = "LINK_GROUP";
    /** @deprecated Enum value doesn't follow codestyle, use MARKETING_CAROUSEL instead */
    ContentCmsComponentType["MARKETINGCAROUSEL"] = "MARKETINGCAROUSEL";
    /** @deprecated Enum value doesn't follow codestyle, use MARKETING_HEADER instead */
    ContentCmsComponentType["MARKETINGHEADER"] = "MARKETINGHEADER";
    ContentCmsComponentType["MARKETING_CAROUSEL"] = "MARKETING_CAROUSEL";
    ContentCmsComponentType["MARKETING_HEADER"] = "MARKETING_HEADER";
    /** @deprecated Enum value doesn't follow codestyle, use PRODUCT_LANE instead */
    ContentCmsComponentType["PRODUCTLANE"] = "PRODUCTLANE";
    ContentCmsComponentType["PRODUCT_LANE"] = "PRODUCT_LANE";
    ContentCmsComponentType["PROPOSITION_HEADER"] = "PROPOSITION_HEADER";
    /** @deprecated Enum value doesn't follow codestyle, use QUERYABLE_RECIPE_LANE instead */
    ContentCmsComponentType["QUERYABLERECIPELANE"] = "QUERYABLERECIPELANE";
    ContentCmsComponentType["QUERYABLE_RECIPE_LANE"] = "QUERYABLE_RECIPE_LANE";
    /** @deprecated Enum value doesn't follow codestyle, use RICH_CONTENT instead */
    ContentCmsComponentType["RICHCONTENT"] = "RICHCONTENT";
    ContentCmsComponentType["RICH_CONTENT"] = "RICH_CONTENT";
    /** @deprecated Enum value doesn't follow codestyle, use SHOP_HEADER instead */
    ContentCmsComponentType["SHOPHEADER"] = "SHOPHEADER";
    /** @deprecated Enum value doesn't follow codestyle, use SHOP_IN_SHOP instead */
    ContentCmsComponentType["SHOPINSHOP"] = "SHOPINSHOP";
    ContentCmsComponentType["SHOP_HEADER"] = "SHOP_HEADER";
    ContentCmsComponentType["SHOP_IN_SHOP"] = "SHOP_IN_SHOP";
    ContentCmsComponentType["SPOTLIGHT_LIST"] = "SPOTLIGHT_LIST";
    /** @deprecated Enum value doesn't follow codestyle, use SUPER_SHOPS instead */
    ContentCmsComponentType["SUPERSHOPS"] = "SUPERSHOPS";
    ContentCmsComponentType["SUPER_SHOPS"] = "SUPER_SHOPS";
    ContentCmsComponentType["TITLE"] = "TITLE";
})(ContentCmsComponentType || (ContentCmsComponentType = {}));
/** Root Component Types */
export var ContentComponentType;
(function (ContentComponentType) {
    ContentComponentType["COMPONENT"] = "COMPONENT";
    ContentComponentType["SUBMENU"] = "SUBMENU";
})(ContentComponentType || (ContentComponentType = {}));
/** Error types for content module */
export var ContentErrorTypes;
(function (ContentErrorTypes) {
    /** Not found error, 404 */
    ContentErrorTypes["NOT_FOUND"] = "NOT_FOUND";
    /** Internal Server Error, 500 */
    ContentErrorTypes["SERVER_ERROR"] = "SERVER_ERROR";
    /** Unauthorized error, 401 */
    ContentErrorTypes["UNAUTHORIZED"] = "UNAUTHORIZED";
    /** not specified error type */
    ContentErrorTypes["UNKNOWN"] = "UNKNOWN";
})(ContentErrorTypes || (ContentErrorTypes = {}));
/** Flex page component types */
export var ContentFlexPageComponentType;
(function (ContentFlexPageComponentType) {
    ContentFlexPageComponentType["ACCORDION"] = "ACCORDION";
    ContentFlexPageComponentType["AHRMS_SPOTLIGHT_LIST"] = "AHRMS_SPOTLIGHT_LIST";
    ContentFlexPageComponentType["ARTICLE"] = "ARTICLE";
    ContentFlexPageComponentType["CURATED_LISTS"] = "CURATED_LISTS";
    ContentFlexPageComponentType["FORM"] = "FORM";
    ContentFlexPageComponentType["HARDCODED_COMPONENT"] = "HARDCODED_COMPONENT";
    /** @deprecated Enum value doesn't follow codestyle, use PRODUCT_LANE instead */
    ContentFlexPageComponentType["PRODUCTLANE"] = "PRODUCTLANE";
    ContentFlexPageComponentType["PRODUCT_LANE"] = "PRODUCT_LANE";
    /** @deprecated Enum value doesn't follow codestyle, use QUERYABLE_RECIPE_LANE instead */
    ContentFlexPageComponentType["QUERYABLERECIPELANE"] = "QUERYABLERECIPELANE";
    ContentFlexPageComponentType["QUERYABLE_RECIPE_LANE"] = "QUERYABLE_RECIPE_LANE";
    /** @deprecated Enum value doesn't follow codestyle, use RICH_CONTENT instead */
    ContentFlexPageComponentType["RICHCONTENT"] = "RICHCONTENT";
    ContentFlexPageComponentType["RICH_CONTENT"] = "RICH_CONTENT";
    ContentFlexPageComponentType["SPOTLIGHT_LIST"] = "SPOTLIGHT_LIST";
    ContentFlexPageComponentType["SUPER_SHOPS"] = "SUPER_SHOPS";
})(ContentFlexPageComponentType || (ContentFlexPageComponentType = {}));
/** Flex page header types */
export var ContentFlexPageHeaderType;
(function (ContentFlexPageHeaderType) {
    /** @deprecated Enum value doesn't follow codestyle, use BRAND_HEADER instead */
    ContentFlexPageHeaderType["BRANDHEADER"] = "BRANDHEADER";
    ContentFlexPageHeaderType["BRAND_HEADER"] = "BRAND_HEADER";
    /** @deprecated Enum value doesn't follow codestyle, use MARKETING_HEADER instead */
    ContentFlexPageHeaderType["MARKETINGHEADER"] = "MARKETINGHEADER";
    ContentFlexPageHeaderType["MARKETING_HEADER"] = "MARKETING_HEADER";
    /** @deprecated Enum value doesn't follow codestyle, use SHOP_HEADER instead */
    ContentFlexPageHeaderType["SHOPHEADER"] = "SHOPHEADER";
    ContentFlexPageHeaderType["SHOP_HEADER"] = "SHOP_HEADER";
})(ContentFlexPageHeaderType || (ContentFlexPageHeaderType = {}));
/** Form Dropdown Render type */
export var ContentFormDropdownRenderType;
(function (ContentFormDropdownRenderType) {
    ContentFormDropdownRenderType["DROPDOWN"] = "DROPDOWN";
    ContentFormDropdownRenderType["RADIOBUTTONS"] = "RADIOBUTTONS";
})(ContentFormDropdownRenderType || (ContentFormDropdownRenderType = {}));
/** Types of the form fields */
export var ContentFormFieldType;
(function (ContentFormFieldType) {
    ContentFormFieldType["CHECKBOX"] = "CHECKBOX";
    ContentFormFieldType["DROPDOWN"] = "DROPDOWN";
    ContentFormFieldType["EMAIL"] = "EMAIL";
    ContentFormFieldType["INFORMATIONBLOCK"] = "INFORMATIONBLOCK";
    ContentFormFieldType["TELEPHONE"] = "TELEPHONE";
    ContentFormFieldType["TERMSBLOCK"] = "TERMSBLOCK";
    ContentFormFieldType["TEXT"] = "TEXT";
    ContentFormFieldType["TEXTAREA"] = "TEXTAREA";
    ContentFormFieldType["UPLOAD"] = "UPLOAD";
})(ContentFormFieldType || (ContentFormFieldType = {}));
/** Content image variant */
export var ContentImageVariantType;
(function (ContentImageVariantType) {
    ContentImageVariantType["CNTDESKTOP"] = "CNTDESKTOP";
    ContentImageVariantType["CNTDESKTOPHD"] = "CNTDESKTOPHD";
    ContentImageVariantType["CNTDESKTOPHDRETINA"] = "CNTDESKTOPHDRETINA";
    ContentImageVariantType["CNTDESKTOPRETINA"] = "CNTDESKTOPRETINA";
    ContentImageVariantType["CNTPHABLET"] = "CNTPHABLET";
    ContentImageVariantType["CNTPHABLETRETINA"] = "CNTPHABLETRETINA";
    ContentImageVariantType["CNTTABLET"] = "CNTTABLET";
    ContentImageVariantType["CNTTABLETRETINA"] = "CNTTABLETRETINA";
    ContentImageVariantType["FULL"] = "FULL";
    ContentImageVariantType["LARGE"] = "LARGE";
    ContentImageVariantType["LARGERETINA"] = "LARGERETINA";
    ContentImageVariantType["MEDIUM"] = "MEDIUM";
    ContentImageVariantType["MEDIUMRETINA"] = "MEDIUMRETINA";
    ContentImageVariantType["ORIGINAL"] = "ORIGINAL";
    ContentImageVariantType["SCLDESKTOP"] = "SCLDESKTOP";
    ContentImageVariantType["SCLDESKTOPHD"] = "SCLDESKTOPHD";
    ContentImageVariantType["SCLDESKTOPHDRETINA"] = "SCLDESKTOPHDRETINA";
    ContentImageVariantType["SCLDESKTOPRETINA"] = "SCLDESKTOPRETINA";
    ContentImageVariantType["SMALL"] = "SMALL";
    ContentImageVariantType["SMALLRETINA"] = "SMALLRETINA";
    ContentImageVariantType["THUMBNAIL"] = "THUMBNAIL";
    ContentImageVariantType["XL"] = "XL";
    ContentImageVariantType["XLRETINA"] = "XLRETINA";
})(ContentImageVariantType || (ContentImageVariantType = {}));
/** Content media types (IMAGE, YOUTUBE, BLUEBILLYWIG) */
export var ContentMediaBlockType;
(function (ContentMediaBlockType) {
    ContentMediaBlockType["BLUEBILLYWIG"] = "BLUEBILLYWIG";
    ContentMediaBlockType["IMAGE"] = "IMAGE";
    ContentMediaBlockType["YOUTUBE"] = "YOUTUBE";
})(ContentMediaBlockType || (ContentMediaBlockType = {}));
/** Content image render type */
export var ContentSpotlightVisualRenderType;
(function (ContentSpotlightVisualRenderType) {
    /** Image is rendered as a cover or packshot */
    ContentSpotlightVisualRenderType["COVER"] = "COVER";
    ContentSpotlightVisualRenderType["PACKSHOT"] = "PACKSHOT";
})(ContentSpotlightVisualRenderType || (ContentSpotlightVisualRenderType = {}));
/** Submenu header focus point */
export var ContentSubmenuFocusPoint;
(function (ContentSubmenuFocusPoint) {
    ContentSubmenuFocusPoint["CENTER"] = "CENTER";
    ContentSubmenuFocusPoint["LEFT"] = "LEFT";
    ContentSubmenuFocusPoint["RIGHT"] = "RIGHT";
})(ContentSubmenuFocusPoint || (ContentSubmenuFocusPoint = {}));
/** Moderation state for a cookbook */
export var CookBookModerated;
(function (CookBookModerated) {
    /** Approved content */
    CookBookModerated["APPROVED"] = "APPROVED";
    /** Removed content */
    CookBookModerated["DELETED"] = "DELETED";
    /** Rejected content */
    CookBookModerated["REJECTED"] = "REJECTED";
    /** abuse reported */
    CookBookModerated["TO_BE_MODERATED_ABUSE_REPORTED"] = "TO_BE_MODERATED_ABUSE_REPORTED";
    /** normal content reportec */
    CookBookModerated["TO_BE_MODERATED_NORMAL_CONTENT"] = "TO_BE_MODERATED_NORMAL_CONTENT";
    /** suspicious content reported */
    CookBookModerated["TO_BE_MODERATED_SUSPICIOUS_CONTENT"] = "TO_BE_MODERATED_SUSPICIOUS_CONTENT";
    /** unknown */
    CookBookModerated["UNKNOWN"] = "UNKNOWN";
})(CookBookModerated || (CookBookModerated = {}));
/** Enum that represents supported Cookie Consent levels */
export var CookieConsentLevel;
(function (CookieConsentLevel) {
    /** Personalized Cookie Consent level */
    CookieConsentLevel["PERSONALIZED"] = "PERSONALIZED";
    /** Social Media Cookie Consent level */
    CookieConsentLevel["SOCIAL_MEDIA"] = "SOCIAL_MEDIA";
})(CookieConsentLevel || (CookieConsentLevel = {}));
/** Type of configurable components */
export var CustomerCareConfiguredContentComponentType;
(function (CustomerCareConfiguredContentComponentType) {
    CustomerCareConfiguredContentComponentType["ACCORDION"] = "ACCORDION";
    CustomerCareConfiguredContentComponentType["ARTICLE"] = "ARTICLE";
    CustomerCareConfiguredContentComponentType["BREADCRUMBS"] = "BREADCRUMBS";
    CustomerCareConfiguredContentComponentType["BUTTONLANE"] = "BUTTONLANE";
    CustomerCareConfiguredContentComponentType["LINKLANE"] = "LINKLANE";
    CustomerCareConfiguredContentComponentType["PAGEMETA"] = "PAGEMETA";
    CustomerCareConfiguredContentComponentType["TITLE"] = "TITLE";
})(CustomerCareConfiguredContentComponentType || (CustomerCareConfiguredContentComponentType = {}));
/** Error types for content module */
export var CustomerCareErrorTypes;
(function (CustomerCareErrorTypes) {
    /** Not found error, 404 */
    CustomerCareErrorTypes["NOT_FOUND"] = "NOT_FOUND";
    /** Internal Server Error, 500 */
    CustomerCareErrorTypes["SERVER_ERROR"] = "SERVER_ERROR";
})(CustomerCareErrorTypes || (CustomerCareErrorTypes = {}));
/** Search response document type */
export var CustomerServiceDocumentType;
(function (CustomerServiceDocumentType) {
    /** Article type for a single "search hit" */
    CustomerServiceDocumentType["CUSTOMER_SERVICE_ARTICLE"] = "CUSTOMER_SERVICE_ARTICLE";
    /** Page type for a single "search hit" */
    CustomerServiceDocumentType["CUSTOMER_SERVICE_PAGE"] = "CUSTOMER_SERVICE_PAGE";
})(CustomerServiceDocumentType || (CustomerServiceDocumentType = {}));
/** Debit Type */
export var DebitType;
(function (DebitType) {
    /** Direct Debit value */
    DebitType["DIRECT_DEBIT"] = "DIRECT_DEBIT";
    /** Invoice Debit value */
    DebitType["INVOICE"] = "INVOICE";
    /** None value */
    DebitType["NONE"] = "NONE";
})(DebitType || (DebitType = {}));
/** Chosen days to receive deliveries */
export var DeliveryBundleDeliveryDays;
(function (DeliveryBundleDeliveryDays) {
    /** Delivery on peak days */
    DeliveryBundleDeliveryDays["MONDAY_SATURDAY"] = "MONDAY_SATURDAY";
    /** Delivery on off-peak days */
    DeliveryBundleDeliveryDays["TUESDAY_THURSDAY"] = "TUESDAY_THURSDAY";
})(DeliveryBundleDeliveryDays || (DeliveryBundleDeliveryDays = {}));
/** Contract length of Delivery Bundle subscription */
export var DeliveryBundleDuration;
(function (DeliveryBundleDuration) {
    /** 6 month subscription */
    DeliveryBundleDuration["HALF_YEAR"] = "HALF_YEAR";
    /** 1 month subscription */
    DeliveryBundleDuration["ONE_MONTH"] = "ONE_MONTH";
    /**
     * 3 month subscription
     * # TODO
     * # not available to new customers
     * # should throw error if someone tries to set this as period
     */
    DeliveryBundleDuration["THREE_MONTHS"] = "THREE_MONTHS";
    /** 1 year subscription */
    DeliveryBundleDuration["YEAR"] = "YEAR";
})(DeliveryBundleDuration || (DeliveryBundleDuration = {}));
/** Payment status of a delivery bundle */
export var DeliveryBundlePaymentStatus;
(function (DeliveryBundlePaymentStatus) {
    /** Payment has been cancelled */
    DeliveryBundlePaymentStatus["CANCELLED"] = "CANCELLED";
    /** Payment has been completed */
    DeliveryBundlePaymentStatus["COMPLETED"] = "COMPLETED";
    /** Payment has expired */
    DeliveryBundlePaymentStatus["EXPIRED"] = "EXPIRED";
    /** Payment has failed */
    DeliveryBundlePaymentStatus["FAILURE"] = "FAILURE";
    /** Payment is newly created */
    DeliveryBundlePaymentStatus["NEW"] = "NEW";
    /** Payment is open */
    DeliveryBundlePaymentStatus["OPEN"] = "OPEN";
})(DeliveryBundlePaymentStatus || (DeliveryBundlePaymentStatus = {}));
/** Method of Delivery */
export var DeliveryMethod;
(function (DeliveryMethod) {
    /** Delivery at a member's location */
    DeliveryMethod["HOME_DELIVERY"] = "HOME_DELIVERY";
    /** Delivery at a pickup location */
    DeliveryMethod["PICKUP"] = "PICKUP";
    /** Delivery at a member specific pickup location */
    DeliveryMethod["PICKUP_HOME_DELIVERY"] = "PICKUP_HOME_DELIVERY";
    /** Unknown method */
    DeliveryMethod["UNKNOWN"] = "UNKNOWN";
})(DeliveryMethod || (DeliveryMethod = {}));
/** Status of delivery */
export var DeliveryStatus;
(function (DeliveryStatus) {
    /** The delivery has been cancelled */
    DeliveryStatus["CANCELLED"] = "CANCELLED";
    /** The delivery has been delivered */
    DeliveryStatus["DELIVERED"] = "DELIVERED";
    /** The order has been created, but a block has not yet been chosen. */
    DeliveryStatus["ENTERED"] = "ENTERED";
    /** The delivery has been created with a timeslot that is valid for 1.5 hours */
    DeliveryStatus["ENTERED_WITH_DELIVERY_BLOCK"] = "ENTERED_WITH_DELIVERY_BLOCK";
    /** The delivery is being packaged */
    DeliveryStatus["PACKAGING"] = "PACKAGING";
    /** The order belonging to the delivery has been reopened */
    DeliveryStatus["REOPENED"] = "REOPENED";
    /** The delivery has been submitted and a timeslot has been reserved */
    DeliveryStatus["SUBMITTED"] = "SUBMITTED";
    /** The order cannot be altered and is being processed (picked/packed) */
    DeliveryStatus["SUBMITTED_WITH_SHORTREC_ETA"] = "SUBMITTED_WITH_SHORTREC_ETA";
    /** The order cannot be altered and is being transported to destination */
    DeliveryStatus["SUBMITTED_WITH_SIMACAN_ETA"] = "SUBMITTED_WITH_SIMACAN_ETA";
    /** Unknown status */
    DeliveryStatus["UNKNOWN"] = "UNKNOWN";
})(DeliveryStatus || (DeliveryStatus = {}));
/** The type of the message */
export var DeliveryTrackTraceInformationMessageType;
(function (DeliveryTrackTraceInformationMessageType) {
    /** Default type used for notifications etc. */
    DeliveryTrackTraceInformationMessageType["DISPLAY"] = "DISPLAY";
    /** Used for google assistant */
    DeliveryTrackTraceInformationMessageType["SPEECH"] = "SPEECH";
})(DeliveryTrackTraceInformationMessageType || (DeliveryTrackTraceInformationMessageType = {}));
/** The type of order */
export var DeliveryTrackTraceInformationOrderType;
(function (DeliveryTrackTraceInformationOrderType) {
    /** DELIVERY */
    DeliveryTrackTraceInformationOrderType["DELIVERY"] = "DELIVERY";
    /** DELIVERY_POINT */
    DeliveryTrackTraceInformationOrderType["DELIVERY_POINT"] = "DELIVERY_POINT";
    /** IN_STORE_PICK */
    DeliveryTrackTraceInformationOrderType["IN_STORE_PICK"] = "IN_STORE_PICK";
    /** PHYSICAL_STORE */
    DeliveryTrackTraceInformationOrderType["PHYSICAL_STORE"] = "PHYSICAL_STORE";
    /** PICKUP */
    DeliveryTrackTraceInformationOrderType["PICKUP"] = "PICKUP";
    /** PICKUP_DELIVERY */
    DeliveryTrackTraceInformationOrderType["PICKUP_DELIVERY"] = "PICKUP_DELIVERY";
    /** SPECIALS_ONLY */
    DeliveryTrackTraceInformationOrderType["SPECIALS_ONLY"] = "SPECIALS_ONLY";
    /** UNKNOWN */
    DeliveryTrackTraceInformationOrderType["UNKNOWN"] = "UNKNOWN";
})(DeliveryTrackTraceInformationOrderType || (DeliveryTrackTraceInformationOrderType = {}));
/** List of possible states the order or delivery can have */
export var DeliveryTrackTraceInformationState;
(function (DeliveryTrackTraceInformationState) {
    /** CANCELLED */
    DeliveryTrackTraceInformationState["CANCELLED"] = "CANCELLED";
    /** DELIVERED */
    DeliveryTrackTraceInformationState["DELIVERED"] = "DELIVERED";
    /** INCIDENT */
    DeliveryTrackTraceInformationState["INCIDENT"] = "INCIDENT";
    /** IN PREPERATION */
    DeliveryTrackTraceInformationState["IN_PREPARATION"] = "IN_PREPARATION";
    /** ORDERED */
    DeliveryTrackTraceInformationState["ORDERED"] = "ORDERED";
    /** OUT FOR DELIVERY */
    DeliveryTrackTraceInformationState["OUT_FOR_DELIVERY"] = "OUT_FOR_DELIVERY";
    /** PICKED UP */
    DeliveryTrackTraceInformationState["PICKED_UP"] = "PICKED_UP";
    /** REOPENED */
    DeliveryTrackTraceInformationState["REOPENED"] = "REOPENED";
    /** TO BE PICKED UP */
    DeliveryTrackTraceInformationState["TO_BE_PICKED_UP"] = "TO_BE_PICKED_UP";
    /** UNKNOWN */
    DeliveryTrackTraceInformationState["UNKNOWN"] = "UNKNOWN";
})(DeliveryTrackTraceInformationState || (DeliveryTrackTraceInformationState = {}));
/** The type of deposit */
export var DepositComplaintDepositType;
(function (DepositComplaintDepositType) {
    DepositComplaintDepositType["BEER_BOTTLE"] = "BEER_BOTTLE";
    DepositComplaintDepositType["BEER_CRATE_12_BOTTLES"] = "BEER_CRATE_12_BOTTLES";
    DepositComplaintDepositType["BEER_CRATE_16_OR_24_BOTTLES"] = "BEER_CRATE_16_OR_24_BOTTLES";
    DepositComplaintDepositType["CAN"] = "CAN";
    DepositComplaintDepositType["FLIP_TOP_BOTTLE"] = "FLIP_TOP_BOTTLE";
    DepositComplaintDepositType["FOLDING_CRATE"] = "FOLDING_CRATE";
    DepositComplaintDepositType["PET_BOTTLE_LARGE"] = "PET_BOTTLE_LARGE";
    DepositComplaintDepositType["PET_BOTTLE_SMALL"] = "PET_BOTTLE_SMALL";
    DepositComplaintDepositType["PLASTIC_BAG"] = "PLASTIC_BAG";
})(DepositComplaintDepositType || (DepositComplaintDepositType = {}));
/** Explanation type */
export var DepositComplaintExplanationType;
(function (DepositComplaintExplanationType) {
    DepositComplaintExplanationType["SETTLED_BY_DELIVERER"] = "SETTLED_BY_DELIVERER";
    DepositComplaintExplanationType["SUBMITTED"] = "SUBMITTED";
})(DepositComplaintExplanationType || (DepositComplaintExplanationType = {}));
/** Optional reimbursement */
export var DepositComplaintReimbursementOption;
(function (DepositComplaintReimbursementOption) {
    DepositComplaintReimbursementOption["FEEDBACK_ONLY"] = "FEEDBACK_ONLY";
    DepositComplaintReimbursementOption["REIMBURSEMENT"] = "REIMBURSEMENT";
})(DepositComplaintReimbursementOption || (DepositComplaintReimbursementOption = {}));
/** Shopping type of the order */
export var DepositComplaintShoppingType;
(function (DepositComplaintShoppingType) {
    /** delivery */
    DepositComplaintShoppingType["DELIVERY"] = "DELIVERY";
    /** delivery point */
    DepositComplaintShoppingType["DELIVERY_POINT"] = "DELIVERY_POINT";
    /** in store pick */
    DepositComplaintShoppingType["IN_STORE_PICK"] = "IN_STORE_PICK";
    /** store */
    DepositComplaintShoppingType["PHYSICAL_STORE"] = "PHYSICAL_STORE";
    /** pickup */
    DepositComplaintShoppingType["PICKUP"] = "PICKUP";
    /** pickup delivery */
    DepositComplaintShoppingType["PICKUP_DELIVERY"] = "PICKUP_DELIVERY";
    /** specials only */
    DepositComplaintShoppingType["SPECIALS_ONLY"] = "SPECIALS_ONLY";
    /** unkown */
    DepositComplaintShoppingType["UNKNOWN"] = "UNKNOWN";
})(DepositComplaintShoppingType || (DepositComplaintShoppingType = {}));
/** Status of the order for deposit complaints */
export var DepositComplaintStatus;
(function (DepositComplaintStatus) {
    /** The order contains deposits that can be returned */
    DepositComplaintStatus["CLAIMABLE"] = "CLAIMABLE";
    /** Maximum deposits in this order have been returned */
    DepositComplaintStatus["MAX_CLAIMED"] = "MAX_CLAIMED";
})(DepositComplaintStatus || (DepositComplaintStatus = {}));
/** This type represents device type. */
export var DeviceType;
(function (DeviceType) {
    DeviceType["MOBILE"] = "MOBILE";
    DeviceType["TABLET"] = "TABLET";
})(DeviceType || (DeviceType = {}));
/** Service charge discount levels */
export var DiscountLevel;
(function (DiscountLevel) {
    /** Maximum charge */
    DiscountLevel["MAXIMUM"] = "MAXIMUM";
    /** Normal charge */
    DiscountLevel["NONE"] = "NONE";
    /** Partial charge */
    DiscountLevel["PARTIAL"] = "PARTIAL";
})(DiscountLevel || (DiscountLevel = {}));
/** All available domains where the users email will be checked on */
export var DomainsEnum;
(function (DomainsEnum) {
    DomainsEnum["AH"] = "AH";
    DomainsEnum["ETOS"] = "ETOS";
    DomainsEnum["GALL"] = "GALL";
})(DomainsEnum || (DomainsEnum = {}));
/**
 * Enum type referencing the content variant of an entry point content. Mostly used for
 * internal purposes to differentiate between the different content types, as GraphQL's
 * query language already supports fetching based on type.
 */
export var EntryPointContentVariantType;
(function (EntryPointContentVariantType) {
    /** Card Entry Point Content. */
    EntryPointContentVariantType["CARD"] = "CARD";
    /** Card Extended Entry Point Content. */
    EntryPointContentVariantType["CARD_EXTENDED"] = "CARD_EXTENDED";
    /** Large Horizontal Entry Point Content. */
    EntryPointContentVariantType["LARGE_HORIZONTAL"] = "LARGE_HORIZONTAL";
    /** Large Vertical Entry Point Content. */
    EntryPointContentVariantType["LARGE_VERTICAL"] = "LARGE_VERTICAL";
    /** Regular Horizontal Entry Point Content. */
    EntryPointContentVariantType["REGULAR_HORIZONTAL"] = "REGULAR_HORIZONTAL";
    /** Regular Horizontal Extended Entry Point Content. */
    EntryPointContentVariantType["REGULAR_HORIZONTAL_EXTENDED"] = "REGULAR_HORIZONTAL_EXTENDED";
    /** Regular Vertical Entry Point Content. */
    EntryPointContentVariantType["REGULAR_VERTICAL"] = "REGULAR_VERTICAL";
})(EntryPointContentVariantType || (EntryPointContentVariantType = {}));
/** Enum type referencing the target type of an entry point target. */
export var EntryPointTargetLinkType;
(function (EntryPointTargetLinkType) {
    /** A deeplink, used by the mobile frontends to route to pages. */
    EntryPointTargetLinkType["DEEPLINK"] = "DEEPLINK";
    /** A weblink. */
    EntryPointTargetLinkType["WEBLINK"] = "WEBLINK";
})(EntryPointTargetLinkType || (EntryPointTargetLinkType = {}));
/** Payment Transaction Currencies */
export var EvalueCurrencyEnum;
(function (EvalueCurrencyEnum) {
    /** Euro - EUR */
    EvalueCurrencyEnum["EUR"] = "EUR";
    /** POINTS */
    EvalueCurrencyEnum["POINTS"] = "POINTS";
})(EvalueCurrencyEnum || (EvalueCurrencyEnum = {}));
/** Transaction Status */
export var EvalueTransactionStatus;
(function (EvalueTransactionStatus) {
    /** Transaction Status - CANCELLED */
    EvalueTransactionStatus["CANCELLED"] = "CANCELLED";
    /** Transaction Status - COMPLETED */
    EvalueTransactionStatus["COMPLETED"] = "COMPLETED";
    /** Transaction Status - REFUNDED */
    EvalueTransactionStatus["REFUNDED"] = "REFUNDED";
    /** Transaction Status - RESERVED */
    EvalueTransactionStatus["RESERVED"] = "RESERVED";
})(EvalueTransactionStatus || (EvalueTransactionStatus = {}));
/** Transaction Type */
export var EvalueTransactionType;
(function (EvalueTransactionType) {
    /** Deposit Transaction Type */
    EvalueTransactionType["DEPOSIT"] = "DEPOSIT";
    /** Withdrawal Transaction Type */
    EvalueTransactionType["WITHDRAWAL"] = "WITHDRAWAL";
})(EvalueTransactionType || (EvalueTransactionType = {}));
export var ExperimentalBonusPromotionType;
(function (ExperimentalBonusPromotionType) {
    ExperimentalBonusPromotionType["AHONLINE"] = "AHONLINE";
    ExperimentalBonusPromotionType["ETOS"] = "ETOS";
    ExperimentalBonusPromotionType["GALL"] = "GALL";
    ExperimentalBonusPromotionType["GALLCARD"] = "GALLCARD";
    ExperimentalBonusPromotionType["INCENTIVE"] = "INCENTIVE";
    ExperimentalBonusPromotionType["NATIONAL"] = "NATIONAL";
    ExperimentalBonusPromotionType["PERSONAL"] = "PERSONAL";
    /** @deprecated get it from the product search */
    ExperimentalBonusPromotionType["PREVIOUSLY_BOUGHT"] = "PREVIOUSLY_BOUGHT";
    /** @deprecated there is a spotlight argument on the query bonusSegments */
    ExperimentalBonusPromotionType["SPOTLIGHT"] = "SPOTLIGHT";
})(ExperimentalBonusPromotionType || (ExperimentalBonusPromotionType = {}));
export var ExperimentalBonusSegmentType;
(function (ExperimentalBonusSegmentType) {
    ExperimentalBonusSegmentType["AH"] = "AH";
    ExperimentalBonusSegmentType["AH_ONLINE_ONLY"] = "AH_ONLINE_ONLY";
    ExperimentalBonusSegmentType["AH_ONLINE_ONLY_SUBTYPE"] = "AH_ONLINE_ONLY_SUBTYPE";
    ExperimentalBonusSegmentType["AH_XL"] = "AH_XL";
    ExperimentalBonusSegmentType["BONUS_BOX"] = "BONUS_BOX";
    ExperimentalBonusSegmentType["BUNDEL"] = "BUNDEL";
    ExperimentalBonusSegmentType["DELIVERY_BUNDLE"] = "DELIVERY_BUNDLE";
    ExperimentalBonusSegmentType["DIGITAL_SCRATCH_CARD"] = "DIGITAL_SCRATCH_CARD";
    ExperimentalBonusSegmentType["ETOS"] = "ETOS";
    ExperimentalBonusSegmentType["FREE_DELIVERY"] = "FREE_DELIVERY";
    ExperimentalBonusSegmentType["GALL_CUSTOMER_CARD"] = "GALL_CUSTOMER_CARD";
    ExperimentalBonusSegmentType["GALL_ONLINE_ONLY"] = "GALL_ONLINE_ONLY";
    ExperimentalBonusSegmentType["NEGATE_DIGITAL_SCRATCH_CARD"] = "NEGATE_DIGITAL_SCRATCH_CARD";
    ExperimentalBonusSegmentType["NEGATE_PREMIUM"] = "NEGATE_PREMIUM";
    ExperimentalBonusSegmentType["PERSONAL_BONUS"] = "PERSONAL_BONUS";
    ExperimentalBonusSegmentType["PREMIUM"] = "PREMIUM";
})(ExperimentalBonusSegmentType || (ExperimentalBonusSegmentType = {}));
export var ExperimentalBonusTheme;
(function (ExperimentalBonusTheme) {
    ExperimentalBonusTheme["BONUS"] = "BONUS";
    ExperimentalBonusTheme["BONUS_BOX"] = "BONUS_BOX";
    ExperimentalBonusTheme["ETOS"] = "ETOS";
    ExperimentalBonusTheme["GALL"] = "GALL";
    ExperimentalBonusTheme["INFINITE"] = "INFINITE";
    ExperimentalBonusTheme["PREMIUM"] = "PREMIUM";
    ExperimentalBonusTheme["TIERED_OFFER"] = "TIERED_OFFER";
})(ExperimentalBonusTheme || (ExperimentalBonusTheme = {}));
export var ExperimentalProductAvailabilityStatus;
(function (ExperimentalProductAvailabilityStatus) {
    ExperimentalProductAvailabilityStatus["FUTURE_ASSORTMENT"] = "FUTURE_ASSORTMENT";
    ExperimentalProductAvailabilityStatus["IN_ASSORTMENT"] = "IN_ASSORTMENT";
    ExperimentalProductAvailabilityStatus["OUT_OF_ASSORTMENT"] = "OUT_OF_ASSORTMENT";
})(ExperimentalProductAvailabilityStatus || (ExperimentalProductAvailabilityStatus = {}));
export var ExperimentalProductIcon;
(function (ExperimentalProductIcon) {
    ExperimentalProductIcon["AVAILABLE_IN_STORE"] = "AVAILABLE_IN_STORE";
    ExperimentalProductIcon["BAKE_OFF"] = "BAKE_OFF";
    ExperimentalProductIcon["DISCOUNT_PACK"] = "DISCOUNT_PACK";
    ExperimentalProductIcon["FROZEN"] = "FROZEN";
    ExperimentalProductIcon["LOCALLY_PRODUCED"] = "LOCALLY_PRODUCED";
    ExperimentalProductIcon["NEW"] = "NEW";
    ExperimentalProductIcon["NUTRISCORE_A"] = "NUTRISCORE_A";
    ExperimentalProductIcon["NUTRISCORE_B"] = "NUTRISCORE_B";
    ExperimentalProductIcon["NUTRISCORE_C"] = "NUTRISCORE_C";
    ExperimentalProductIcon["NUTRISCORE_D"] = "NUTRISCORE_D";
    ExperimentalProductIcon["NUTRISCORE_E"] = "NUTRISCORE_E";
    ExperimentalProductIcon["ORGANIC"] = "ORGANIC";
    ExperimentalProductIcon["PRICE_FAVORITE"] = "PRICE_FAVORITE";
    ExperimentalProductIcon["PRIZE_WINNER"] = "PRIZE_WINNER";
    ExperimentalProductIcon["VEGAN"] = "VEGAN";
    ExperimentalProductIcon["VEGETARIAN"] = "VEGETARIAN";
    ExperimentalProductIcon["XL_STORE"] = "XL_STORE";
})(ExperimentalProductIcon || (ExperimentalProductIcon = {}));
export var ExperimentalProductImageAngle;
(function (ExperimentalProductImageAngle) {
    ExperimentalProductImageAngle["ANGLE_2D1"] = "ANGLE_2D1";
    ExperimentalProductImageAngle["ANGLE_4D1"] = "ANGLE_4D1";
    ExperimentalProductImageAngle["ANGLE_4D2"] = "ANGLE_4D2";
    ExperimentalProductImageAngle["ANGLE_4D3"] = "ANGLE_4D3";
    ExperimentalProductImageAngle["ANGLE_4D4"] = "ANGLE_4D4";
    ExperimentalProductImageAngle["ANGLE_4D5"] = "ANGLE_4D5";
    ExperimentalProductImageAngle["ANGLE_4D6"] = "ANGLE_4D6";
    ExperimentalProductImageAngle["ANGLE_4D7"] = "ANGLE_4D7";
    ExperimentalProductImageAngle["ANGLE_5D1"] = "ANGLE_5D1";
    ExperimentalProductImageAngle["ANGLE_5D2"] = "ANGLE_5D2";
    ExperimentalProductImageAngle["ANGLE_5D3"] = "ANGLE_5D3";
    ExperimentalProductImageAngle["HERO"] = "HERO";
})(ExperimentalProductImageAngle || (ExperimentalProductImageAngle = {}));
export var ExperimentalProductPropertyIcon;
(function (ExperimentalProductPropertyIcon) {
    ExperimentalProductPropertyIcon["BAKE_OFF"] = "BAKE_OFF";
    ExperimentalProductPropertyIcon["DISCOUNT_PACK"] = "DISCOUNT_PACK";
    ExperimentalProductPropertyIcon["FROZEN"] = "FROZEN";
    ExperimentalProductPropertyIcon["LOCALLY_PRODUCED"] = "LOCALLY_PRODUCED";
    ExperimentalProductPropertyIcon["NEW"] = "NEW";
    ExperimentalProductPropertyIcon["ORGANIC"] = "ORGANIC";
    ExperimentalProductPropertyIcon["PRICE_FAVORITE"] = "PRICE_FAVORITE";
    ExperimentalProductPropertyIcon["PRIZE_WINNER"] = "PRIZE_WINNER";
    ExperimentalProductPropertyIcon["VEGAN"] = "VEGAN";
    ExperimentalProductPropertyIcon["VEGETARIAN"] = "VEGETARIAN";
    ExperimentalProductPropertyIcon["XL_STORE"] = "XL_STORE";
})(ExperimentalProductPropertyIcon || (ExperimentalProductPropertyIcon = {}));
export var ExperimentalProductShopType;
(function (ExperimentalProductShopType) {
    ExperimentalProductShopType["AH"] = "AH";
    ExperimentalProductShopType["ET"] = "ET";
    ExperimentalProductShopType["GA"] = "GA";
})(ExperimentalProductShopType || (ExperimentalProductShopType = {}));
export var ExperimentalProductUnavailableReason;
(function (ExperimentalProductUnavailableReason) {
    ExperimentalProductUnavailableReason["FUTURE_ASSORTMENT"] = "FUTURE_ASSORTMENT";
    ExperimentalProductUnavailableReason["NOT_AT_THIS_PICKUP_POINT"] = "NOT_AT_THIS_PICKUP_POINT";
    ExperimentalProductUnavailableReason["NOT_FOR_PICKUP"] = "NOT_FOR_PICKUP";
    ExperimentalProductUnavailableReason["NO_LONGER_ONLINE"] = "NO_LONGER_ONLINE";
    ExperimentalProductUnavailableReason["OUT_OF_ASSORTMENT"] = "OUT_OF_ASSORTMENT";
    ExperimentalProductUnavailableReason["SHOP_ONLY"] = "SHOP_ONLY";
    ExperimentalProductUnavailableReason["SOLD_OUT"] = "SOLD_OUT";
})(ExperimentalProductUnavailableReason || (ExperimentalProductUnavailableReason = {}));
export var ExperimentalProductVariantType;
(function (ExperimentalProductVariantType) {
    ExperimentalProductVariantType["PRIMARY"] = "PRIMARY";
    ExperimentalProductVariantType["SECONDARY"] = "SECONDARY";
})(ExperimentalProductVariantType || (ExperimentalProductVariantType = {}));
/** Possible facet types */
export var ExperimentalSearchFacetType;
(function (ExperimentalSearchFacetType) {
    /** Facet type that has conformance to value/values in a hierarchical order */
    ExperimentalSearchFacetType["HIERARCHY"] = "HIERARCHY";
    /** Facet type that has conformance to multiple values */
    ExperimentalSearchFacetType["MULTIPLE"] = "MULTIPLE";
    /** Facet type that has conformance to a range */
    ExperimentalSearchFacetType["RANGE"] = "RANGE";
    /** Facet type that has conformance to a single value */
    ExperimentalSearchFacetType["SINGLE"] = "SINGLE";
})(ExperimentalSearchFacetType || (ExperimentalSearchFacetType = {}));
/** Possible search products intent types */
export var ExperimentalSearchIntentType;
(function (ExperimentalSearchIntentType) {
    /** Intent type for product browsing */
    ExperimentalSearchIntentType["BROWSE"] = "BROWSE";
    /** Intent type for ordering online */
    ExperimentalSearchIntentType["ONLINE"] = "ONLINE";
    /** Intent type for store order */
    ExperimentalSearchIntentType["STORE"] = "STORE";
})(ExperimentalSearchIntentType || (ExperimentalSearchIntentType = {}));
/** Possible sorting types for search */
export var ExperimentalSearchProductsSortType;
(function (ExperimentalSearchProductsSortType) {
    /** Sorting type based on product NUTRI-SCORE */
    ExperimentalSearchProductsSortType["NUTRI_SCORE_A_E"] = "NUTRI_SCORE_A_E";
    /** Sorting type based on product price, from HIGH to LOW */
    ExperimentalSearchProductsSortType["PRICE_HIGH_LOW"] = "PRICE_HIGH_LOW";
    /** Sorting type based on product price, from LOW to HIGH */
    ExperimentalSearchProductsSortType["PRICE_LOW_HIGH"] = "PRICE_LOW_HIGH";
    /** Sorting type based on product RELEVANCE */
    ExperimentalSearchProductsSortType["RELEVANCE"] = "RELEVANCE";
})(ExperimentalSearchProductsSortType || (ExperimentalSearchProductsSortType = {}));
/** Explanation type */
export var ExplanationType;
(function (ExplanationType) {
    /** Cannot be returned */
    ExplanationType["CANNOT_BE_RETURNED"] = "CANNOT_BE_RETURNED";
    /** Excluded from self service */
    ExplanationType["EXCLUDED_FROM_SELF_SERVICE"] = "EXCLUDED_FROM_SELF_SERVICE";
    /** Not delivered */
    ExplanationType["NOT_DELIVERED"] = "NOT_DELIVERED";
    /** Processed */
    ExplanationType["PROCESSED"] = "PROCESSED";
    /** Settled by deliverer */
    ExplanationType["SETTLED_BY_DELIVERER"] = "SETTLED_BY_DELIVERER";
    /** Submitted */
    ExplanationType["SUBMITTED"] = "SUBMITTED";
    /** WARN_FOR_SHORT_EXPIRATION */
    ExplanationType["WARN_DISCOUNT_ALREADY_APPLIED"] = "WARN_DISCOUNT_ALREADY_APPLIED";
    /** WARN_FOR_SHORT_EXPIRATION */
    ExplanationType["WARN_FOR_SHORT_EXPIRATION"] = "WARN_FOR_SHORT_EXPIRATION";
})(ExplanationType || (ExplanationType = {}));
/** Shared by enum */
export var FavoriteListSharedBy;
(function (FavoriteListSharedBy) {
    /** You shared this list with others */
    FavoriteListSharedBy["ME"] = "ME";
    /** Not a shared list */
    FavoriteListSharedBy["NOT_SHARED"] = "NOT_SHARED";
    /** Someone else shared this list with you */
    FavoriteListSharedBy["OTHER"] = "OTHER";
})(FavoriteListSharedBy || (FavoriteListSharedBy = {}));
/** Feedback channel */
export var FeedbackChannel;
(function (FeedbackChannel) {
    FeedbackChannel["AH_APP_BE"] = "AH_APP_BE";
    FeedbackChannel["AH_APP_NL"] = "AH_APP_NL";
    FeedbackChannel["AH_BE"] = "AH_BE";
    FeedbackChannel["AH_NL"] = "AH_NL";
    FeedbackChannel["DEALS_AH_NL"] = "DEALS_AH_NL";
    FeedbackChannel["MY_LIFESTYLE_COACH_APP"] = "MY_LIFESTYLE_COACH_APP";
})(FeedbackChannel || (FeedbackChannel = {}));
/** Feedback form type for ces feedback */
export var FeedbackFormType;
(function (FeedbackFormType) {
    /** Deposit complaint form */
    FeedbackFormType["DEPOSIT_FORM"] = "DEPOSIT_FORM";
    /** Product complaint form online */
    FeedbackFormType["PRODUCT_COMPLAINT_FORM_ONLINE"] = "PRODUCT_COMPLAINT_FORM_ONLINE";
    /** Product complaint form store */
    FeedbackFormType["PRODUCT_COMPLAINT_FORM_STORE"] = "PRODUCT_COMPLAINT_FORM_STORE";
    /** Product Return form */
    FeedbackFormType["RETURN_FORM"] = "RETURN_FORM";
})(FeedbackFormType || (FeedbackFormType = {}));
/** The type of loyalty program */
export var FeedbackLoyaltyProgram;
(function (FeedbackLoyaltyProgram) {
    FeedbackLoyaltyProgram["AH_MILES"] = "AH_MILES";
    FeedbackLoyaltyProgram["AH_PREMIUM"] = "AH_PREMIUM";
    FeedbackLoyaltyProgram["DELIVERY_BUNDLE"] = "DELIVERY_BUNDLE";
    FeedbackLoyaltyProgram["PURCHASE_STAMPS"] = "PURCHASE_STAMPS";
    FeedbackLoyaltyProgram["SAVING_CAMPAIGNS"] = "SAVING_CAMPAIGNS";
})(FeedbackLoyaltyProgram || (FeedbackLoyaltyProgram = {}));
/** ShoppingType of the order eligible for feedback */
export var FeedbackOrderShoppingType;
(function (FeedbackOrderShoppingType) {
    FeedbackOrderShoppingType["DELIVERY"] = "DELIVERY";
    FeedbackOrderShoppingType["DELIVERY_POINT"] = "DELIVERY_POINT";
    FeedbackOrderShoppingType["IN_STORE_PICK"] = "IN_STORE_PICK";
    FeedbackOrderShoppingType["PHYSICAL_STORE"] = "PHYSICAL_STORE";
    FeedbackOrderShoppingType["PICKUP"] = "PICKUP";
    FeedbackOrderShoppingType["PICKUP_DELIVERY"] = "PICKUP_DELIVERY";
    FeedbackOrderShoppingType["SPECIALS_ONLY"] = "SPECIALS_ONLY";
    FeedbackOrderShoppingType["UNKNOWN"] = "UNKNOWN";
})(FeedbackOrderShoppingType || (FeedbackOrderShoppingType = {}));
/** The type of Shopping */
export var FeedbackShoppingType;
(function (FeedbackShoppingType) {
    FeedbackShoppingType["ONLINE"] = "ONLINE";
    FeedbackShoppingType["STORE"] = "STORE";
})(FeedbackShoppingType || (FeedbackShoppingType = {}));
/** The source of feedback */
export var FeedbackSource;
(function (FeedbackSource) {
    FeedbackSource["CES_FORM"] = "CES_FORM";
    FeedbackSource["CUSTOMER_CONTENT_SCORE_FORM"] = "CUSTOMER_CONTENT_SCORE_FORM";
    FeedbackSource["CUSTOMER_EFFORT_SCORE_FORM"] = "CUSTOMER_EFFORT_SCORE_FORM";
    FeedbackSource["CUSTOMER_INTERACTION_SCORE_FORM"] = "CUSTOMER_INTERACTION_SCORE_FORM";
    FeedbackSource["DELIVERY_APP"] = "DELIVERY_APP";
    FeedbackSource["DEPOSIT_FORM"] = "DEPOSIT_FORM";
    FeedbackSource["DIGITAL_ASSISTANT"] = "DIGITAL_ASSISTANT";
    FeedbackSource["EMAIL"] = "EMAIL";
    FeedbackSource["FAQ"] = "FAQ";
    FeedbackSource["FEEDBACK_FORM"] = "FEEDBACK_FORM";
    FeedbackSource["PAYMENT_PROCESSOR"] = "PAYMENT_PROCESSOR";
    FeedbackSource["PRODUCT_COMPLAINT_FORM"] = "PRODUCT_COMPLAINT_FORM";
    FeedbackSource["PRODUCT_RETURN_FORM"] = "PRODUCT_RETURN_FORM";
    FeedbackSource["SALESFORCE"] = "SALESFORCE";
})(FeedbackSource || (FeedbackSource = {}));
/** The type of feedback. */
export var FeedbackType;
(function (FeedbackType) {
    FeedbackType["ACCESSIBILITY"] = "ACCESSIBILITY";
    FeedbackType["ACTION_CODE"] = "ACTION_CODE";
    FeedbackType["ASSORTMENT"] = "ASSORTMENT";
    FeedbackType["AVAILABILITY"] = "AVAILABILITY";
    FeedbackType["BONUS"] = "BONUS";
    FeedbackType["BONUS_PERSONAL"] = "BONUS_PERSONAL";
    FeedbackType["CALCULATION_ERROR"] = "CALCULATION_ERROR";
    FeedbackType["CANCELLED_BY_CUSTOMER"] = "CANCELLED_BY_CUSTOMER";
    FeedbackType["CANCELLED_BY_CUSTOMER_SUPPORT"] = "CANCELLED_BY_CUSTOMER_SUPPORT";
    FeedbackType["COMPLETENESS"] = "COMPLETENESS";
    FeedbackType["CONTENT"] = "CONTENT";
    FeedbackType["CORRECTION_PARTNERSHOP"] = "CORRECTION_PARTNERSHOP";
    FeedbackType["DAMAGED"] = "DAMAGED";
    FeedbackType["DEFROSTED"] = "DEFROSTED";
    FeedbackType["DELIVERY_SLOTS"] = "DELIVERY_SLOTS";
    FeedbackType["DELIVERY_TIMELINESS"] = "DELIVERY_TIMELINESS";
    FeedbackType["DEPOSITS_EXCEED_ORDER_VALUE"] = "DEPOSITS_EXCEED_ORDER_VALUE";
    FeedbackType["DOUBLE_PAYMENT"] = "DOUBLE_PAYMENT";
    FeedbackType["FORM"] = "FORM";
    FeedbackType["FROZEN"] = "FROZEN";
    FeedbackType["FUNCTIONING_APP"] = "FUNCTIONING_APP";
    FeedbackType["FUNCTIONING_WEBSITE"] = "FUNCTIONING_WEBSITE";
    FeedbackType["GENERAL"] = "GENERAL";
    FeedbackType["GENERAL_COMPENSATION"] = "GENERAL_COMPENSATION";
    FeedbackType["GENERAL_CORRECTION"] = "GENERAL_CORRECTION";
    FeedbackType["HYGIENE"] = "HYGIENE";
    FeedbackType["LOYALTY"] = "LOYALTY";
    FeedbackType["MISSING_LOAD_CARRIER"] = "MISSING_LOAD_CARRIER";
    FeedbackType["NOT_AT_HOME"] = "NOT_AT_HOME";
    FeedbackType["NOT_PICKED_UP"] = "NOT_PICKED_UP";
    FeedbackType["OUTAGE"] = "OUTAGE";
    FeedbackType["PACKAGING_DEPOSIT"] = "PACKAGING_DEPOSIT";
    FeedbackType["PAST_EXPIRY_MARGIN"] = "PAST_EXPIRY_MARGIN";
    FeedbackType["PAYMENT"] = "PAYMENT";
    FeedbackType["PICKUP_ORDER_COSTS"] = "PICKUP_ORDER_COSTS";
    FeedbackType["PRICING"] = "PRICING";
    FeedbackType["QUALITY"] = "QUALITY";
    FeedbackType["RETURN"] = "RETURN";
    FeedbackType["SEARCH"] = "SEARCH";
    FeedbackType["SERVICE_HOURS"] = "SERVICE_HOURS";
    FeedbackType["SPEED"] = "SPEED";
    FeedbackType["SPOILED"] = "SPOILED";
    FeedbackType["STAFF"] = "STAFF";
    FeedbackType["SUSTAINABILITY"] = "SUSTAINABILITY";
    FeedbackType["WRONG_DELIVERY"] = "WRONG_DELIVERY";
})(FeedbackType || (FeedbackType = {}));
/** Publication state */
export var FolderState;
(function (FolderState) {
    /** Folder is not publicly visible. */
    FolderState["OFFLINE"] = "OFFLINE";
    /** Folder is publicly visible */
    FolderState["ONLINE"] = "ONLINE";
})(FolderState || (FolderState = {}));
/** Type of cancellation for a fulfillment. */
export var FulfillmentCancellationReasonType;
(function (FulfillmentCancellationReasonType) {
    /** Order is cancelled because of an address change. */
    FulfillmentCancellationReasonType["ADDRESS_CHANGE"] = "ADDRESS_CHANGE";
    /** Order is cancelled because not approved by the procurement system. */
    FulfillmentCancellationReasonType["B2B_NOT_APPROVED"] = "B2B_NOT_APPROVED";
    /** Order is cancelled by AH. */
    FulfillmentCancellationReasonType["BY_AH"] = "BY_AH";
    /** Order is cancelled by the customer. */
    FulfillmentCancellationReasonType["BY_CUSTOMER"] = "BY_CUSTOMER";
    /** Order is cancelled because the minimum order value of a fixed delivery moment order wasn't reached before cut-off time. */
    FulfillmentCancellationReasonType["VBM_VALUE_NOT_REACHED"] = "VBM_VALUE_NOT_REACHED";
})(FulfillmentCancellationReasonType || (FulfillmentCancellationReasonType = {}));
/** The method of delivery for a fulfillment. */
export var FulfillmentDeliveryMethod;
(function (FulfillmentDeliveryMethod) {
    /** Home delivery */
    FulfillmentDeliveryMethod["HOME_DELIVERY"] = "HOME_DELIVERY";
    /** Pick up delivery */
    FulfillmentDeliveryMethod["PICKUP"] = "PICKUP";
    /** Pick up home delivery */
    FulfillmentDeliveryMethod["PICKUP_HOME_DELIVERY"] = "PICKUP_HOME_DELIVERY";
})(FulfillmentDeliveryMethod || (FulfillmentDeliveryMethod = {}));
/** Whether the fulfillment is still open or already closed (or both). */
export var FulfillmentStatus;
(function (FulfillmentStatus) {
    /** Delivery status - all orders */
    FulfillmentStatus["ALL"] = "ALL";
    /** Delivery status - closed orders */
    FulfillmentStatus["CLOSED"] = "CLOSED";
    /** Delivery status - open orders */
    FulfillmentStatus["OPEN"] = "OPEN";
})(FulfillmentStatus || (FulfillmentStatus = {}));
/** Gender options available within Ahold */
export var Gender;
(function (Gender) {
    /** Female */
    Gender["FEMALE"] = "FEMALE";
    /** IRRELEVANT */
    Gender["IRRELEVANT"] = "IRRELEVANT";
    /** Male */
    Gender["MALE"] = "MALE";
})(Gender || (Gender = {}));
/** Different types of grocery lists */
export var GroceryListType;
(function (GroceryListType) {
    GroceryListType["FAVORITE"] = "FAVORITE";
    GroceryListType["SHARED"] = "SHARED";
    GroceryListType["SHOPPING"] = "SHOPPING";
})(GroceryListType || (GroceryListType = {}));
/** Icon Type of LifestyleAdvice */
export var LifestyleAdviceIconType;
(function (LifestyleAdviceIconType) {
    /** Alcohol */
    LifestyleAdviceIconType["ALCOHOL"] = "ALCOHOL";
    /** Balance */
    LifestyleAdviceIconType["BALANCE"] = "BALANCE";
    /** Bedtime */
    LifestyleAdviceIconType["BEDTIME"] = "BEDTIME";
    /** Breaks */
    LifestyleAdviceIconType["BREAKS"] = "BREAKS";
    /** Drinks */
    LifestyleAdviceIconType["DRINKS"] = "DRINKS";
    /** Endurance */
    LifestyleAdviceIconType["ENDURANCE"] = "ENDURANCE";
    /** Fall asleep */
    LifestyleAdviceIconType["FALL_ASLEEP"] = "FALL_ASLEEP";
    /** Fish */
    LifestyleAdviceIconType["FISH"] = "FISH";
    /** Fruit */
    LifestyleAdviceIconType["FRUIT"] = "FRUIT";
    /** Meat */
    LifestyleAdviceIconType["MEAT"] = "MEAT";
    /** Shifts */
    LifestyleAdviceIconType["SHIFTS"] = "SHIFTS";
    /** Sitting */
    LifestyleAdviceIconType["SITTING"] = "SITTING";
    /** Smoking */
    LifestyleAdviceIconType["SMOKING"] = "SMOKING";
    /** Strength */
    LifestyleAdviceIconType["STRENGTH"] = "STRENGTH";
    /** Stress */
    LifestyleAdviceIconType["STRESS"] = "STRESS";
    /** Sugar */
    LifestyleAdviceIconType["SUGAR"] = "SUGAR";
    /** Vegetables */
    LifestyleAdviceIconType["VEGETABLES"] = "VEGETABLES";
    /** Wholewheat */
    LifestyleAdviceIconType["WHOLEWHEAT"] = "WHOLEWHEAT";
})(LifestyleAdviceIconType || (LifestyleAdviceIconType = {}));
/** Path of LifestyleAdvice */
export var LifestyleAdvicePath;
(function (LifestyleAdvicePath) {
    /** Hub */
    LifestyleAdvicePath["HUB"] = "HUB";
    /** Lifestyle check */
    LifestyleAdvicePath["LIFESTYLE_CHECK"] = "LIFESTYLE_CHECK";
})(LifestyleAdvicePath || (LifestyleAdvicePath = {}));
/** Label of LifestyleAdviceTopic */
export var LifestyleAdviceTopicLabel;
(function (LifestyleAdviceTopicLabel) {
    /** Advice */
    LifestyleAdviceTopicLabel["ADVICE"] = "ADVICE";
    /** Can improve */
    LifestyleAdviceTopicLabel["CAN_IMPROVE"] = "CAN_IMPROVE";
    /** Okay */
    LifestyleAdviceTopicLabel["OKAY"] = "OKAY";
})(LifestyleAdviceTopicLabel || (LifestyleAdviceTopicLabel = {}));
/** Lifestylecheck Chapter Icon Type */
export var LifestyleCheckChapterIconType;
(function (LifestyleCheckChapterIconType) {
    /** Chapter icon type for Exercising questions */
    LifestyleCheckChapterIconType["EXERCISING"] = "EXERCISING";
    /** Chapter icon type for Food questions */
    LifestyleCheckChapterIconType["NUTRITION"] = "NUTRITION";
    /** Chapter icon type for Relaxation questions */
    LifestyleCheckChapterIconType["RELAXATION"] = "RELAXATION";
    /** Chapter icon type for Resting questions */
    LifestyleCheckChapterIconType["RESTING"] = "RESTING";
})(LifestyleCheckChapterIconType || (LifestyleCheckChapterIconType = {}));
/** State of Lifestylecheck Chapter */
export var LifestyleCheckChapterStatus;
(function (LifestyleCheckChapterStatus) {
    /** Member has finished the LifestyleCheck chapter */
    LifestyleCheckChapterStatus["FINISHED"] = "FINISHED";
    /** Member hasnt started the LifestyleCheck chapter yet */
    LifestyleCheckChapterStatus["NOT_STARTED"] = "NOT_STARTED";
})(LifestyleCheckChapterStatus || (LifestyleCheckChapterStatus = {}));
/** Lifestylecheck Intake Answer Icon Type */
export var LifestyleCheckIntakeAnswerIconType;
(function (LifestyleCheckIntakeAnswerIconType) {
    /** Intake Answer icon type for Energy option */
    LifestyleCheckIntakeAnswerIconType["ENERGY"] = "ENERGY";
    /** Intake Answer icon type for Healthy Aging option */
    LifestyleCheckIntakeAnswerIconType["HEALTHY_AGING"] = "HEALTHY_AGING";
    /** Intake Answer icon type for Resting option */
    LifestyleCheckIntakeAnswerIconType["RESTING"] = "RESTING";
    /** Intake Answer icon type for Scales option */
    LifestyleCheckIntakeAnswerIconType["SCALES"] = "SCALES";
    /** Intake Answer icon type for Stamina option */
    LifestyleCheckIntakeAnswerIconType["STAMINA"] = "STAMINA";
    /** Intake Answer icon type for Less Stress option */
    LifestyleCheckIntakeAnswerIconType["STRESS_LESS"] = "STRESS_LESS";
    /** Intake Answer icon type for Unclear option */
    LifestyleCheckIntakeAnswerIconType["UNCLEAR"] = "UNCLEAR";
})(LifestyleCheckIntakeAnswerIconType || (LifestyleCheckIntakeAnswerIconType = {}));
/** State of Lifestylecheck Intake */
export var LifestyleCheckIntakeStatus;
(function (LifestyleCheckIntakeStatus) {
    /** Member has finished the LifestyleCheck intake */
    LifestyleCheckIntakeStatus["FINISHED"] = "FINISHED";
    /** Member hasnt started the LifestyleCheck intake yet */
    LifestyleCheckIntakeStatus["NOT_STARTED"] = "NOT_STARTED";
})(LifestyleCheckIntakeStatus || (LifestyleCheckIntakeStatus = {}));
/** Lifestylecheck Navigation Intent */
export var LifestyleCheckNavigationIntent;
(function (LifestyleCheckNavigationIntent) {
    /** Lifestyle Check results, shortcut to go to the advice based on your Lifestyle Check results */
    LifestyleCheckNavigationIntent["LIFESTYLE_ADVICE"] = "LIFESTYLE_ADVICE";
    /** Lifestyle Check, a way for us get information about your lifestyle and give you advice on how to improve it */
    LifestyleCheckNavigationIntent["LIFESTYLE_CHECK"] = "LIFESTYLE_CHECK";
    /** Lifestyle Check deeplink, shortcut to go to the check based on your progression */
    LifestyleCheckNavigationIntent["LIFESTYLE_CHECK_DEEPLINK"] = "LIFESTYLE_CHECK_DEEPLINK";
    /** Lifestyle Hub, giving you all kinds of lifestyle information based on what you have told us about yourself */
    LifestyleCheckNavigationIntent["LIFESTYLE_HUB"] = "LIFESTYLE_HUB";
    /** Lifestyle Check results, shortcut to go to the results of your Lifestyle Check */
    LifestyleCheckNavigationIntent["LIFESTYLE_RESULTS"] = "LIFESTYLE_RESULTS";
})(LifestyleCheckNavigationIntent || (LifestyleCheckNavigationIntent = {}));
/** Lifestylecheck Navigation Suggestion */
export var LifestyleCheckNavigationSuggestion;
(function (LifestyleCheckNavigationSuggestion) {
    /** Lifestyle Hub, locked version */
    LifestyleCheckNavigationSuggestion["HUB_LOCKED"] = "HUB_LOCKED";
    /** Lifestyle Hub, unlocked version */
    LifestyleCheckNavigationSuggestion["HUB_UNLOCKED"] = "HUB_UNLOCKED";
    /** Lifestyle Check Advice screen */
    LifestyleCheckNavigationSuggestion["LIFESTYLE_ADVICE"] = "LIFESTYLE_ADVICE";
    /** Lifestyle Check Chapter overview screen */
    LifestyleCheckNavigationSuggestion["LIFESTYLE_CHECK_CHAPTERS"] = "LIFESTYLE_CHECK_CHAPTERS";
    /** Lifestyle Check introduction/opt-in screen */
    LifestyleCheckNavigationSuggestion["LIFESTYLE_CHECK_WELCOME"] = "LIFESTYLE_CHECK_WELCOME";
    /** Lifestyle Check Results screen */
    LifestyleCheckNavigationSuggestion["LIFESTYLE_RESULTS_DEFAULT"] = "LIFESTYLE_RESULTS_DEFAULT";
    /** Lifestyle Check Results screen, with a different caption on the button */
    LifestyleCheckNavigationSuggestion["LIFESTYLE_RESULTS_RESTART"] = "LIFESTYLE_RESULTS_RESTART";
})(LifestyleCheckNavigationSuggestion || (LifestyleCheckNavigationSuggestion = {}));
/** LifestyleErrors Enum */
export var LifestyleErrors;
(function (LifestyleErrors) {
    /** Member Not Authenticated */
    LifestyleErrors["MEMBER_NOT_AUTHENTICATED"] = "MEMBER_NOT_AUTHENTICATED";
})(LifestyleErrors || (LifestyleErrors = {}));
/** Link type */
export var LinkType;
(function (LinkType) {
    LinkType["DEEPLINK"] = "DEEPLINK";
    LinkType["PRODUCT_SHELF"] = "PRODUCT_SHELF";
    LinkType["RECIPE"] = "RECIPE";
    LinkType["THEME_PAGE"] = "THEME_PAGE";
    LinkType["UNKNOWN"] = "UNKNOWN";
    LinkType["URL"] = "URL";
    LinkType["WEBFLOW"] = "WEBFLOW";
})(LinkType || (LinkType = {}));
/** Returns the type of the loyalty card */
export var LoyaltyCard;
(function (LoyaltyCard) {
    LoyaltyCard["AIRMILES"] = "AIRMILES";
    LoyaltyCard["BONUS"] = "BONUS";
    LoyaltyCard["ETOS"] = "ETOS";
    LoyaltyCard["GALL"] = "GALL";
})(LoyaltyCard || (LoyaltyCard = {}));
/** A type containing the status of a challenge. */
export var LoyaltyChallengeStatus;
(function (LoyaltyChallengeStatus) {
    /** The challenge can be activated by the member. */
    LoyaltyChallengeStatus["ACTIVATABLE"] = "ACTIVATABLE";
    /** The challenge has been completed successfully. */
    LoyaltyChallengeStatus["COMPLETED"] = "COMPLETED";
    /** The member failed to complete the challenge (in time). */
    LoyaltyChallengeStatus["FAILED"] = "FAILED";
    /** The challenge is currently in progress. */
    LoyaltyChallengeStatus["IN_PROGRESS"] = "IN_PROGRESS";
    /** The member opted into the challenge, but the current date is before the challenge start date. */
    LoyaltyChallengeStatus["NOT_STARTED"] = "NOT_STARTED";
})(LoyaltyChallengeStatus || (LoyaltyChallengeStatus = {}));
/** A type containing the status of a step. */
export var LoyaltyChallengeStepStatus;
(function (LoyaltyChallengeStepStatus) {
    /** The step has been completed. */
    LoyaltyChallengeStepStatus["COMPLETED"] = "COMPLETED";
    /** The step has been failed. */
    LoyaltyChallengeStepStatus["FAILED"] = "FAILED";
    /** The step will be active in the future. */
    LoyaltyChallengeStepStatus["FUTURE"] = "FUTURE";
    /** The step is currently active and in progress. */
    LoyaltyChallengeStepStatus["IN_PROGRESS"] = "IN_PROGRESS";
})(LoyaltyChallengeStepStatus || (LoyaltyChallengeStepStatus = {}));
/** An enumeration that contains the various types of step targets. */
export var LoyaltyChallengeStepTargetType;
(function (LoyaltyChallengeStepTargetType) {
    /** Money. */
    LoyaltyChallengeStepTargetType["EUROS"] = "EUROS";
    /** Generic points. */
    LoyaltyChallengeStepTargetType["POINTS"] = "POINTS";
})(LoyaltyChallengeStepTargetType || (LoyaltyChallengeStepTargetType = {}));
/**
 * An enumeration that contains the various types that a term might related to. Used for
 * displaying the term correctly towards the member.
 */
export var LoyaltyChallengeTermType;
(function (LoyaltyChallengeTermType) {
    /** The term is of a generic type. */
    LoyaltyChallengeTermType["GENERIC"] = "GENERIC";
    /** The term relates to something with regards to online activity. */
    LoyaltyChallengeTermType["ONLINE"] = "ONLINE";
    /** The term excludes one or multiple types of products or taxonomies. */
    LoyaltyChallengeTermType["PRODUCT_EXCLUSION"] = "PRODUCT_EXCLUSION";
    /** The term relates to something with regards to store activity. */
    LoyaltyChallengeTermType["STORE"] = "STORE";
})(LoyaltyChallengeTermType || (LoyaltyChallengeTermType = {}));
/**
 * An enumeration that contains the various types that a challenge or step can be. Used for
 * communication towards the member about the progress of the challenge or step.
 */
export var LoyaltyChallengeType;
(function (LoyaltyChallengeType) {
    /** A basic challenge, not bound by time. */
    LoyaltyChallengeType["BASIC"] = "BASIC";
    /** A daily challenge. */
    LoyaltyChallengeType["DAILY"] = "DAILY";
    /** A weekly challenge. */
    LoyaltyChallengeType["WEEKLY"] = "WEEKLY";
})(LoyaltyChallengeType || (LoyaltyChallengeType = {}));
/**
 * @deprecated - Use LoyaltyPointsTransactionType
 * An enum to indicate the reason for a transaction.
 */
export var LoyaltyPointsTransactionReason;
(function (LoyaltyPointsTransactionReason) {
    /**
     * A correction by a store employee or the customer service department. For example, a
     * customer complained that they did not receive any loyalty points after a store transaction.
     */
    LoyaltyPointsTransactionReason["CORRECTION"] = "CORRECTION";
    /**
     * Transaction as part of stamp sharing flows. For example, a customer has received or sent
     * loyalty points to another customer.
     */
    LoyaltyPointsTransactionReason["GIFT"] = "GIFT";
    /**
     * Transaction as part of (regular) activity online. For example, a customer has placed
     * an order and has received loyalty points as a result of that.
     */
    LoyaltyPointsTransactionReason["ONLINE"] = "ONLINE";
    /**
     * Boosted transaction (Premium) as part of (regular) activity online. For example, a customer
     * has placed an order and has received double loyalty points due to Premium as a result of that.
     */
    LoyaltyPointsTransactionReason["ONLINE_BOOSTED"] = "ONLINE_BOOSTED";
    /**
     * Transaction as part of (regular) activity in the store. For example, a customer has
     * bought products and received loyalty points as part of it. Or a customer has redeemed
     * loyalty points for a discount on a loyalty product.
     */
    LoyaltyPointsTransactionReason["STORE"] = "STORE";
    /**
     * Boosted transaction (Premium) as part of (regular) activity in the store. For example,
     * a customer has bought products and received double loyalty points due to Premium as part
     * of it.
     */
    LoyaltyPointsTransactionReason["STORE_BOOSTED"] = "STORE_BOOSTED";
    /**
     * The reason for the transaction is unknown. This should not happen often and might
     * indicate a data problem.
     */
    LoyaltyPointsTransactionReason["UNKNOWN"] = "UNKNOWN";
})(LoyaltyPointsTransactionReason || (LoyaltyPointsTransactionReason = {}));
/** An enum to indicate the type of a transaction. */
export var LoyaltyPointsTransactionType;
(function (LoyaltyPointsTransactionType) {
    /**
     * A correction by a store employee or the customer service department. For example, a
     * customer complained that they did not receive any loyalty points after a store transaction.
     */
    LoyaltyPointsTransactionType["CORRECTION"] = "CORRECTION";
    /**
     * Transaction as part of stamp sharing flows. For example, a customer has received
     * loyalty points from another customer.
     */
    LoyaltyPointsTransactionType["GIFT_RECEIVED"] = "GIFT_RECEIVED";
    /**
     * Transaction as part of stamp sharing flows. For example, a customer has sent
     * loyalty points to another customer.
     */
    LoyaltyPointsTransactionType["GIFT_SENT"] = "GIFT_SENT";
    /**
     * Transaction as part of (regular) activity online. For example, a customer has placed
     * an order and has received loyalty points as a result of that.
     */
    LoyaltyPointsTransactionType["ONLINE"] = "ONLINE";
    /**
     * Boosted transaction (Premium) as part of (regular) activity online. For example, a customer
     * has placed an order and has received double loyalty points due to Premium as a result of that.
     */
    LoyaltyPointsTransactionType["ONLINE_BOOSTED"] = "ONLINE_BOOSTED";
    /** Customer redeems Purchase Stamps. */
    LoyaltyPointsTransactionType["PAYOUT"] = "PAYOUT";
    /** Customer redeems a digital saving program stamps, e.g. during Scratching. */
    LoyaltyPointsTransactionType["REDEEMED"] = "REDEEMED";
    /**
     * Transaction as part of (regular) activity in the store. For example, a customer has
     * bought products and received loyalty points as part of it. Or a customer has redeemed
     * loyalty points for a discount on a loyalty product.
     */
    LoyaltyPointsTransactionType["STORE"] = "STORE";
    /**
     * Boosted transaction (Premium) as part of (regular) activity in the store. For example,
     * a customer has bought products and received double loyalty points due to Premium as part
     * of it.
     */
    LoyaltyPointsTransactionType["STORE_BOOSTED"] = "STORE_BOOSTED";
    /**
     * The reason for the transaction is unknown. This should not happen often and might
     * indicate a data problem.
     */
    LoyaltyPointsTransactionType["UNKNOWN"] = "UNKNOWN";
})(LoyaltyPointsTransactionType || (LoyaltyPointsTransactionType = {}));
/** Type of the CTA link. */
export var LoyaltyProgramCtaLinkType;
(function (LoyaltyProgramCtaLinkType) {
    /** The link is a deep link. */
    LoyaltyProgramCtaLinkType["DEEPLINK"] = "DEEPLINK";
    /** The link is a web link. */
    LoyaltyProgramCtaLinkType["WEBLINK"] = "WEBLINK";
})(LoyaltyProgramCtaLinkType || (LoyaltyProgramCtaLinkType = {}));
/** Enum that indicates the program state. */
export var LoyaltyProgramState;
(function (LoyaltyProgramState) {
    /** The program is active. Its saving period is now, but its redemption period is not. */
    LoyaltyProgramState["ACTIVE"] = "ACTIVE";
    /** The program is active and points can currently be redeemed. */
    LoyaltyProgramState["ACTIVE_AND_REDEEMABLE"] = "ACTIVE_AND_REDEEMABLE";
    /** The program has finished, saving and redeeming are no longer possible. */
    LoyaltyProgramState["FINISHED"] = "FINISHED";
    /**
     * The program has finished, saving is no longer possible. Redeeming is also not yet
     * possible, as this can be done in the future.
     */
    LoyaltyProgramState["FINISHED_AND_FUTURE_REDEEMABLE"] = "FINISHED_AND_FUTURE_REDEEMABLE";
    /** The program has finished, saving is no longer possible. However, redeeming still is. */
    LoyaltyProgramState["FINISHED_AND_REDEEMABLE"] = "FINISHED_AND_REDEEMABLE";
    /** The program has not yet started. Its saving period is in the future. */
    LoyaltyProgramState["FUTURE"] = "FUTURE";
    /** The program is in an unknown state. */
    LoyaltyProgramState["UNKNOWN"] = "UNKNOWN";
})(LoyaltyProgramState || (LoyaltyProgramState = {}));
/** Enum that indicates the program type. */
export var LoyaltyProgramType;
(function (LoyaltyProgramType) {
    /** Digital Savings program. These are programs such as Bestek, Handdoeken or Efteling. */
    LoyaltyProgramType["DIGITAL_SAVINGS"] = "DIGITAL_SAVINGS";
    /** Digital Scratching program. These are programs such as Zomerkrassen. */
    LoyaltyProgramType["DIGITAL_SCRATCHING"] = "DIGITAL_SCRATCHING";
    /** Koopzegels program. There is only one such program. */
    LoyaltyProgramType["KOOPZEGELS"] = "KOOPZEGELS";
    /** To go program. These are programs such as Sapje, Broodje or Koffie. */
    LoyaltyProgramType["TO_GO"] = "TO_GO";
})(LoyaltyProgramType || (LoyaltyProgramType = {}));
/** All member diet options */
export var MemberDietPreferencesOptionType;
(function (MemberDietPreferencesOptionType) {
    /** GLUTEN_FREE */
    MemberDietPreferencesOptionType["GLUTEN_FREE"] = "GLUTEN_FREE";
    /** LACTOSE_FREE */
    MemberDietPreferencesOptionType["LACTOSE_FREE"] = "LACTOSE_FREE";
})(MemberDietPreferencesOptionType || (MemberDietPreferencesOptionType = {}));
/** Status of member */
export var MemberLoginState;
(function (MemberLoginState) {
    /** Logged in customer */
    MemberLoginState["LOGGEDON"] = "LOGGEDON";
    /** Returning recognised customer, not logged in */
    MemberLoginState["RETURNING"] = "RETURNING";
    /** anonymous user */
    MemberLoginState["UNKNOWN"] = "UNKNOWN";
})(MemberLoginState || (MemberLoginState = {}));
/** All member meat frequency options for FLEXITARIAN diet only */
export var MemberMeatFrequencyPreferenceOptionType;
(function (MemberMeatFrequencyPreferenceOptionType) {
    /** OFTEN */
    MemberMeatFrequencyPreferenceOptionType["OFTEN"] = "OFTEN";
    /** RARELY */
    MemberMeatFrequencyPreferenceOptionType["RARELY"] = "RARELY";
    /** REGULARLY */
    MemberMeatFrequencyPreferenceOptionType["REGULARLY"] = "REGULARLY";
})(MemberMeatFrequencyPreferenceOptionType || (MemberMeatFrequencyPreferenceOptionType = {}));
/** All member protein options */
export var MemberMeatPreferencesOptionType;
(function (MemberMeatPreferencesOptionType) {
    /** FLEXITARIAN */
    MemberMeatPreferencesOptionType["FLEXITARIAN"] = "FLEXITARIAN";
    /** PESCATARIAN */
    MemberMeatPreferencesOptionType["PESCATARIAN"] = "PESCATARIAN";
    /** VEGAN */
    MemberMeatPreferencesOptionType["VEGAN"] = "VEGAN";
    /** VEGETARIAN */
    MemberMeatPreferencesOptionType["VEGETARIAN"] = "VEGETARIAN";
})(MemberMeatPreferencesOptionType || (MemberMeatPreferencesOptionType = {}));
/** All member nutrition preference options */
export var MemberNutritionPreferenceOptionType;
(function (MemberNutritionPreferenceOptionType) {
    /** KETO */
    MemberNutritionPreferenceOptionType["KETO"] = "KETO";
    /** LOW CALORIES */
    MemberNutritionPreferenceOptionType["LOW_CALORIES"] = "LOW_CALORIES";
    /** LOW CARBS */
    MemberNutritionPreferenceOptionType["LOW_CARBS"] = "LOW_CARBS";
    /** PROTEIN RICH */
    MemberNutritionPreferenceOptionType["PROTEIN_RICH"] = "PROTEIN_RICH";
})(MemberNutritionPreferenceOptionType || (MemberNutritionPreferenceOptionType = {}));
/** All member protein options */
export var MemberProteinPreferencesOptionType;
(function (MemberProteinPreferencesOptionType) {
    /** ALWAYS */
    MemberProteinPreferencesOptionType["ALWAYS"] = "ALWAYS";
    /** NEVER */
    MemberProteinPreferencesOptionType["NEVER"] = "NEVER";
    /** SOMETIMES */
    MemberProteinPreferencesOptionType["SOMETIMES"] = "SOMETIMES";
})(MemberProteinPreferencesOptionType || (MemberProteinPreferencesOptionType = {}));
/** Member recipe origin type */
export var MemberRecipeOriginType;
(function (MemberRecipeOriginType) {
    /** Member created */
    MemberRecipeOriginType["MEMBER_CREATED"] = "MEMBER_CREATED";
    /** Member scraped */
    MemberRecipeOriginType["MEMBER_SCRAPED"] = "MEMBER_SCRAPED";
})(MemberRecipeOriginType || (MemberRecipeOriginType = {}));
/** Chat channel entrypoint */
export var MessengerChannelTypeEntrypoint;
(function (MessengerChannelTypeEntrypoint) {
    MessengerChannelTypeEntrypoint["CHAT"] = "CHAT";
    MessengerChannelTypeEntrypoint["PHONE"] = "PHONE";
})(MessengerChannelTypeEntrypoint || (MessengerChannelTypeEntrypoint = {}));
/** All available event types in a conversation */
export var MessengerConversationEventType;
(function (MessengerConversationEventType) {
    MessengerConversationEventType["MESSENGER_CLOSED_EVENT"] = "MESSENGER_CLOSED_EVENT";
    MessengerConversationEventType["MESSENGER_HANDLER_FILE_SENT_EVENT"] = "MESSENGER_HANDLER_FILE_SENT_EVENT";
    MessengerConversationEventType["MESSENGER_HANDLER_IMAGE_SENT_EVENT"] = "MESSENGER_HANDLER_IMAGE_SENT_EVENT";
    MessengerConversationEventType["MESSENGER_HANDLER_LINK_LIST_SENT_EVENT"] = "MESSENGER_HANDLER_LINK_LIST_SENT_EVENT";
    MessengerConversationEventType["MESSENGER_HANDLER_MESSAGE_SENT_EVENT"] = "MESSENGER_HANDLER_MESSAGE_SENT_EVENT";
    MessengerConversationEventType["MESSENGER_HANDLER_TABLE_SENT_EVENT"] = "MESSENGER_HANDLER_TABLE_SENT_EVENT";
    MessengerConversationEventType["MESSENGER_MEMBER_FILE_SENT_EVENT"] = "MESSENGER_MEMBER_FILE_SENT_EVENT";
    MessengerConversationEventType["MESSENGER_MEMBER_IMAGE_SENT_EVENT"] = "MESSENGER_MEMBER_IMAGE_SENT_EVENT";
    MessengerConversationEventType["MESSENGER_MEMBER_MESSAGE_SENT_EVENT"] = "MESSENGER_MEMBER_MESSAGE_SENT_EVENT";
    MessengerConversationEventType["MESSENGER_REOPENED_EVENT"] = "MESSENGER_REOPENED_EVENT";
})(MessengerConversationEventType || (MessengerConversationEventType = {}));
/** the type of link */
export var MessengerHyperLinkType;
(function (MessengerHyperLinkType) {
    /** highlighted */
    MessengerHyperLinkType["HIGHLIGHT"] = "HIGHLIGHT";
    /** standard */
    MessengerHyperLinkType["STANDARD"] = "STANDARD";
})(MessengerHyperLinkType || (MessengerHyperLinkType = {}));
/** Status */
export var MessengerStatus;
(function (MessengerStatus) {
    MessengerStatus["CLOSED"] = "CLOSED";
    MessengerStatus["OPEN"] = "OPEN";
})(MessengerStatus || (MessengerStatus = {}));
/** The different kinds of error state that a customer can be in with regards to the AH Miles program. */
export var MilesErrorState;
(function (MilesErrorState) {
    /**
     * The customer does not have a (valid) authentication token to fetch their balance at Air Miles.
     * They need to complete the LMN auth flow. They are, however, opted in for Air Miles.
     */
    MilesErrorState["AUTHENTICATION_REQUIRED"] = "AUTHENTICATION_REQUIRED";
    /** The customer is not opted in for the AH Miles program. */
    MilesErrorState["NOT_OPTED_IN"] = "NOT_OPTED_IN";
})(MilesErrorState || (MilesErrorState = {}));
/** Enum with values of status for miles */
export var MilesStatus;
(function (MilesStatus) {
    /** Account has been created */
    MilesStatus["CREATED"] = "CREATED";
    /** Something went wrong when trying to create account */
    MilesStatus["ERROR"] = "ERROR";
    /** Account is already existing (Email needs to be unique) */
    MilesStatus["EXISTING"] = "EXISTING";
})(MilesStatus || (MilesStatus = {}));
export var MutationResultStatus;
(function (MutationResultStatus) {
    /** Mutation failed completely */
    MutationResultStatus["FAILED"] = "FAILED";
    /** Mutation succeeded partially */
    MutationResultStatus["PARTIAL"] = "PARTIAL";
    /** Mutation succeeded */
    MutationResultStatus["SUCCESS"] = "SUCCESS";
})(MutationResultStatus || (MutationResultStatus = {}));
/** Enum for notification icons */
export var NotificationIcon;
(function (NotificationIcon) {
    /** delivery icon */
    NotificationIcon["DELIVERY"] = "DELIVERY";
    /** home delivery icon */
    NotificationIcon["HOME_DELIVERY"] = "HOME_DELIVERY";
    /** pickup icon */
    NotificationIcon["PICKUP"] = "PICKUP";
    /** pickup home delivery icon */
    NotificationIcon["PICKUP_HOME_DELIVERY"] = "PICKUP_HOME_DELIVERY";
})(NotificationIcon || (NotificationIcon = {}));
/** Enum Priority type of notification */
export var NotificationPriorityType;
(function (NotificationPriorityType) {
    /** e.g. safety warnings and product recalls */
    NotificationPriorityType["HIGH"] = "HIGH";
    /** e.g. customer care messages, outages */
    NotificationPriorityType["MEDIUM"] = "MEDIUM";
})(NotificationPriorityType || (NotificationPriorityType = {}));
/** NotificationType */
export var NotificationType;
(function (NotificationType) {
    /** type for safety warnings, product recalls and failures which impacts users e.g. priority notifications. Will return all CMS notifications. */
    NotificationType["CMS"] = "CMS";
    /** type for safety warnings, product recalls and failures which impacts users e.g. priority notifications. Will only return CMS notifications which have isGlobalNotification set to true. */
    NotificationType["CMS_GLOBAL"] = "CMS_GLOBAL";
    /** type for safety warnings, product recalls and failures which impacts users e.g. priority notifications. Will only return CMS notifications which have isGlobalNotification set to true and will return 'HIGH' priority notifications as one combined notification. */
    NotificationType["CMS_GLOBAL_COMBINED"] = "CMS_GLOBAL_COMBINED";
    /** type for safety warnings, product recalls and failures which impacts users e.g. priority notifications. Will only return CMS notifications which have isGlobalNotification set to false. */
    NotificationType["CMS_NOT_GLOBAL"] = "CMS_NOT_GLOBAL";
    /** type for delivery notification */
    NotificationType["ORDER"] = "ORDER";
})(NotificationType || (NotificationType = {}));
/** Nudge types, which indicated the category of slots. SUSTAINABLE or EXCLUDE_INEFFICIENT. More to come soon */
export var NudgeType;
(function (NudgeType) {
    /** When a slots is excluded based on the delta values */
    NudgeType["EXCLUDE_INEFFICIENT"] = "EXCLUDE_INEFFICIENT";
    /** Special milkman routes which contains 2 hour-max slots. */
    NudgeType["MILKMAN"] = "MILKMAN";
    /** Service fee discount. */
    NudgeType["SERVICE_FEE_DISCOUNT"] = "SERVICE_FEE_DISCOUNT";
    /** When a slot is eco friendly it gets the sustainable nudge type */
    NudgeType["SUSTAINABLE"] = "SUSTAINABLE";
    /** Unknown nudge type. */
    NudgeType["UNKNOWN"] = "UNKNOWN";
})(NudgeType || (NudgeType = {}));
/** The method of an OCI shop session */
export var OciShopSession;
(function (OciShopSession) {
    /** Default order */
    OciShopSession["DEFAULT"] = "DEFAULT";
    /** Reopenable order */
    OciShopSession["REOPENABLE"] = "REOPENABLE";
})(OciShopSession || (OciShopSession = {}));
/** The type of store */
export var OfflineReceiptStoreType;
(function (OfflineReceiptStoreType) {
    /** albert heijn */
    OfflineReceiptStoreType["AH_ALBERT"] = "AH_ALBERT";
    /** albert heijn belgium */
    OfflineReceiptStoreType["AH_BELGIUM"] = "AH_BELGIUM";
    /** albert heijn dntg */
    OfflineReceiptStoreType["AH_DNTG"] = "AH_DNTG";
    /** albert heijn regular */
    OfflineReceiptStoreType["AH_REGULAR"] = "AH_REGULAR";
    /** albert heijn regular old */
    OfflineReceiptStoreType["AH_REGULAR_OLD"] = "AH_REGULAR_OLD";
    /** albert heijn to go */
    OfflineReceiptStoreType["AH_TOGO"] = "AH_TOGO";
    /** albert heijn xl */
    OfflineReceiptStoreType["AH_XL"] = "AH_XL";
    /** etos franchise store */
    OfflineReceiptStoreType["ETOS_FRANCHISE_STORE"] = "ETOS_FRANCHISE_STORE";
    /** etos store */
    OfflineReceiptStoreType["ETOS_STORE"] = "ETOS_STORE";
})(OfflineReceiptStoreType || (OfflineReceiptStoreType = {}));
/** This type represents operating system. */
export var OperatingSystem;
(function (OperatingSystem) {
    OperatingSystem["ANDROID"] = "ANDROID";
    OperatingSystem["IOS"] = "IOS";
})(OperatingSystem || (OperatingSystem = {}));
/** The status of an order's delivery. */
export var OrderDeliveryStatus;
(function (OrderDeliveryStatus) {
    /** The delivery has been cancelled */
    OrderDeliveryStatus["CANCELLED"] = "CANCELLED";
    /** The delivery has been delivered */
    OrderDeliveryStatus["DELIVERED"] = "DELIVERED";
    /** The delivery has been entered */
    OrderDeliveryStatus["ENTERED"] = "ENTERED";
    /** The delivery has been created with a timeslot that is valid for 1.5 hours */
    OrderDeliveryStatus["ENTERED_WITH_DELIVERY_BLOCK"] = "ENTERED_WITH_DELIVERY_BLOCK";
    /** The delivery is being packaged */
    OrderDeliveryStatus["PACKAGING"] = "PACKAGING";
    /** The order belonging to the delivery has been reopened */
    OrderDeliveryStatus["REOPENED"] = "REOPENED";
    /** The delivery has been submitted and a timeslot has been reserved */
    OrderDeliveryStatus["SUBMITTED"] = "SUBMITTED";
    /** The delivery has been submitted with a short eta */
    OrderDeliveryStatus["SUBMITTED_WITH_SHORTREC_ETA"] = "SUBMITTED_WITH_SHORTREC_ETA";
    /** The delivery has been submitted */
    OrderDeliveryStatus["SUBMITTED_WITH_SIMACAN_ETA"] = "SUBMITTED_WITH_SIMACAN_ETA";
    /** The delivery status is unknown */
    OrderDeliveryStatus["UNKNOWN"] = "UNKNOWN";
})(OrderDeliveryStatus || (OrderDeliveryStatus = {}));
/** Shopping type of the order */
export var OrderShoppingType;
(function (OrderShoppingType) {
    /** order gets delivered to the user */
    OrderShoppingType["DELIVERY"] = "DELIVERY";
    /** Order can be collected on pickup point */
    OrderShoppingType["DELIVERY_POINT"] = "DELIVERY_POINT";
    /** Order is picked up from the store */
    OrderShoppingType["IN_STORE_PICK"] = "IN_STORE_PICK";
    /** order is made in physical store */
    OrderShoppingType["PHYSICAL_STORE"] = "PHYSICAL_STORE";
    /** Order is pickup */
    OrderShoppingType["PICKUP"] = "PICKUP";
    /** Order will be delivered to pickup point */
    OrderShoppingType["PICKUP_DELIVERY"] = "PICKUP_DELIVERY";
    /** Specials only */
    OrderShoppingType["SPECIALS_ONLY"] = "SPECIALS_ONLY";
    /** shopping type unknown */
    OrderShoppingType["UNKNOWN"] = "UNKNOWN";
})(OrderShoppingType || (OrderShoppingType = {}));
/** States order can be in */
export var OrderState;
(function (OrderState) {
    /** The order has been cancelled */
    OrderState["CANCELLED"] = "CANCELLED";
    /** The order has been delivered */
    OrderState["DELIVERED"] = "DELIVERED";
    /** The order is being packaged */
    OrderState["ENTERED"] = "ENTERED";
    /** The order has been created with a timeslot that is valid for 1.5 hours */
    OrderState["ENTERED_WITH_DELIVERY_BLOCK"] = "ENTERED_WITH_DELIVERY_BLOCK";
    /** The order has been reopened */
    OrderState["REOPENED"] = "REOPENED";
    /** The order has been submitted and a timeslot has been reserved */
    OrderState["SUBMITTED"] = "SUBMITTED";
    /** The order cannot be altered and is being processed (picked/packed) */
    OrderState["SUBMITTED_WITH_SHORTREC_ETA"] = "SUBMITTED_WITH_SHORTREC_ETA";
    /** The order cannot be altered and is being transported to destination */
    OrderState["SUBMITTED_WITH_SIMACAN_ETA"] = "SUBMITTED_WITH_SIMACAN_ETA";
})(OrderState || (OrderState = {}));
/** Supported payment action types. QR_CODE for WEB(BEL) and REDIRECT for WEB(NLD)/ANDROID/IOS */
export var PaymentActionType;
(function (PaymentActionType) {
    /** Challenge */
    PaymentActionType["CHALLENGE"] = "CHALLENGE";
    /** Poll */
    PaymentActionType["POLL_STATUS"] = "POLL_STATUS";
    /** QR_CODE Action for WEB(BEL) */
    PaymentActionType["QR_CODE"] = "QR_CODE";
    /** REDIRECT Action for WEB(NLD)/ANDROID/IOS/APPLICATION */
    PaymentActionType["REDIRECT"] = "REDIRECT";
})(PaymentActionType || (PaymentActionType = {}));
/** Card Type to update DCT Card (Required by Payments) */
export var PaymentCardType;
(function (PaymentCardType) {
    /** DCT Card Type */
    PaymentCardType["DCT"] = "DCT";
    /** GiftCard CardType */
    PaymentCardType["GIFT_CARD"] = "GIFT_CARD";
})(PaymentCardType || (PaymentCardType = {}));
/** Channel of processing */
export var PaymentChannel;
(function (PaymentChannel) {
    /** Mobile (Android) */
    PaymentChannel["ANDROID"] = "ANDROID";
    /** Mobile (iOS) */
    PaymentChannel["IOS"] = "IOS";
    /** Web (Web Browser) */
    PaymentChannel["WEB"] = "WEB";
})(PaymentChannel || (PaymentChannel = {}));
/** Identifies disruption in the issuer services */
export var PaymentIssuerAvailability;
(function (PaymentIssuerAvailability) {
    /** Issuer Services are Disrupted */
    PaymentIssuerAvailability["DISRUPTED"] = "DISRUPTED";
    /** issuer is stable and available */
    PaymentIssuerAvailability["STABLE"] = "STABLE";
})(PaymentIssuerAvailability || (PaymentIssuerAvailability = {}));
/** Payment method that the customer can use */
export var PaymentMethod;
(function (PaymentMethod) {
    /** Belgium Payment Method similar to iDEAL */
    PaymentMethod["BANCONTACT_MOBILE"] = "BANCONTACT_MOBILE";
    /** Correction transaction */
    PaymentMethod["CORRECTION"] = "CORRECTION";
    /** Debit Card Tokenization, Reserving amounts on bank accounts */
    PaymentMethod["DCT"] = "DCT";
    /** E Value */
    PaymentMethod["EVALUE"] = "EVALUE";
    /** Gift card */
    PaymentMethod["GIFT_CARD"] = "GIFT_CARD";
    /** Instantly pay through Ideal */
    PaymentMethod["IDEAL"] = "IDEAL";
    /** Pay at the delivery moment */
    PaymentMethod["PAY_AT_DELIVERY"] = "PAY_AT_DELIVERY";
    /** Purchase Stamps */
    PaymentMethod["PURCHASE_STAMPS"] = "PURCHASE_STAMPS";
})(PaymentMethod || (PaymentMethod = {}));
/** Payment Mutation Status */
export var PaymentMutationStatus;
(function (PaymentMutationStatus) {
    /** Failed */
    PaymentMutationStatus["FAILED"] = "FAILED";
    /** In Progress */
    PaymentMutationStatus["IN_PROGRESS"] = "IN_PROGRESS";
    /** Success */
    PaymentMutationStatus["SUCCESS"] = "SUCCESS";
})(PaymentMutationStatus || (PaymentMutationStatus = {}));
/** Defines status of an operation */
export var PaymentOperationStatus;
(function (PaymentOperationStatus) {
    /** Declined */
    PaymentOperationStatus["DECLINED"] = "DECLINED";
    /** Expired */
    PaymentOperationStatus["EXPIRED"] = "EXPIRED";
    /** Failed */
    PaymentOperationStatus["FAILED"] = "FAILED";
    /** New */
    PaymentOperationStatus["NEW"] = "NEW";
    /** Obsolete */
    PaymentOperationStatus["OBSOLETE"] = "OBSOLETE";
    /** Pending */
    PaymentOperationStatus["PENDING"] = "PENDING";
    /** Skipped */
    PaymentOperationStatus["SKIPPED"] = "SKIPPED";
    /** success */
    PaymentOperationStatus["SUCCESS"] = "SUCCESS";
})(PaymentOperationStatus || (PaymentOperationStatus = {}));
/** Type of operation that is executed */
export var PaymentOperationType;
(function (PaymentOperationType) {
    /** adjust */
    PaymentOperationType["ADJUST"] = "ADJUST";
    /** cancel */
    PaymentOperationType["CANCEL"] = "CANCEL";
    /** capture */
    PaymentOperationType["CAPTURE"] = "CAPTURE";
    /** create */
    PaymentOperationType["CREATE"] = "CREATE";
    /** extend */
    PaymentOperationType["EXTEND"] = "EXTEND";
    /** rollback */
    PaymentOperationType["ROLLBACK"] = "ROLLBACK";
})(PaymentOperationType || (PaymentOperationType = {}));
/** Status of the PaymentOption */
export var PaymentOptionStatus;
(function (PaymentOptionStatus) {
    /** ACTIVE */
    PaymentOptionStatus["ACTIVE"] = "ACTIVE";
    /** DISABLED */
    PaymentOptionStatus["DISABLED"] = "DISABLED";
    /** Enrollment Disabled */
    PaymentOptionStatus["ENROLLMENT_DISABLED"] = "ENROLLMENT_DISABLED";
})(PaymentOptionStatus || (PaymentOptionStatus = {}));
/** SDK key */
export var PaymentProcessingSdkType;
(function (PaymentProcessingSdkType) {
    /** Adyen Payment Processing SDK */
    PaymentProcessingSdkType["ADYEN"] = "ADYEN";
})(PaymentProcessingSdkType || (PaymentProcessingSdkType = {}));
/** Payment SDK Type */
export var PaymentSdkType;
(function (PaymentSdkType) {
    /** Adyen SDK */
    PaymentSdkType["ADYEN"] = "ADYEN";
})(PaymentSdkType || (PaymentSdkType = {}));
/** The return type of a payment. This is one from the Payments domain. */
export var PaymentStatus;
(function (PaymentStatus) {
    /** Payment Cancelled */
    PaymentStatus["CANCELLED"] = "CANCELLED";
    /** Payment failed */
    PaymentStatus["FAILED"] = "FAILED";
    /** Payment in progress */
    PaymentStatus["IN_PROGRESS"] = "IN_PROGRESS";
    /** New payment */
    PaymentStatus["NEW"] = "NEW";
    /** Payment successful */
    PaymentStatus["SUCCESS"] = "SUCCESS";
})(PaymentStatus || (PaymentStatus = {}));
/** Provider of Psp */
export var PaymentTokenPspProvider;
(function (PaymentTokenPspProvider) {
    /** Adyen */
    PaymentTokenPspProvider["ADYEN"] = "ADYEN";
    /** AH */
    PaymentTokenPspProvider["AH"] = "AH";
    /** ING */
    PaymentTokenPspProvider["ING"] = "ING";
    /** Intersolve */
    PaymentTokenPspProvider["INTERSOLVE"] = "INTERSOLVE";
})(PaymentTokenPspProvider || (PaymentTokenPspProvider = {}));
/** Card status of the payment token */
export var PaymentTokenStatus;
(function (PaymentTokenStatus) {
    /** Card is active */
    PaymentTokenStatus["ACTIVE"] = "ACTIVE";
    /** Card has been deleted */
    PaymentTokenStatus["DELETED"] = "DELETED";
    /** Card has been expired */
    PaymentTokenStatus["EXPIRED"] = "EXPIRED";
    /** Card is inactive */
    PaymentTokenStatus["INACTIVE"] = "INACTIVE";
    /** Card is suspended */
    PaymentTokenStatus["SUSPENDED"] = "SUSPENDED";
})(PaymentTokenStatus || (PaymentTokenStatus = {}));
/** Payment Transaction Currencies */
export var PaymentTransactionCurrencies;
(function (PaymentTransactionCurrencies) {
    /** Euro - EUR */
    PaymentTransactionCurrencies["EUR"] = "EUR";
})(PaymentTransactionCurrencies || (PaymentTransactionCurrencies = {}));
/** Payment Transaction Status */
export var PaymentTransactionStatus;
(function (PaymentTransactionStatus) {
    /** authorized */
    PaymentTransactionStatus["AUTHORIZED"] = "AUTHORIZED";
    /** cancelled */
    PaymentTransactionStatus["CANCELLED"] = "CANCELLED";
    /** cancelling */
    PaymentTransactionStatus["CANCELLING"] = "CANCELLING";
    /** capturing */
    PaymentTransactionStatus["CAPTURING"] = "CAPTURING";
    /** completed */
    PaymentTransactionStatus["COMPLETED"] = "COMPLETED";
    /** declined */
    PaymentTransactionStatus["DECLINED"] = "DECLINED";
    /** expired */
    PaymentTransactionStatus["EXPIRED"] = "EXPIRED";
    /** failed */
    PaymentTransactionStatus["FAILED"] = "FAILED";
    /** new */
    PaymentTransactionStatus["NEW"] = "NEW";
    /** pending */
    PaymentTransactionStatus["PENDING"] = "PENDING";
})(PaymentTransactionStatus || (PaymentTransactionStatus = {}));
/** Replacement of GiftCard Response code */
export var PaymentsTokenOnboardingResponseCode;
(function (PaymentsTokenOnboardingResponseCode) {
    /** Gift Card is already connected */
    PaymentsTokenOnboardingResponseCode["ALREADY_CONNECTED"] = "ALREADY_CONNECTED";
    /** Gift Card Approvded */
    PaymentsTokenOnboardingResponseCode["APPROVED"] = "APPROVED";
    /** GiftCard is declined */
    PaymentsTokenOnboardingResponseCode["DECLINED"] = "DECLINED";
    /** General Error */
    PaymentsTokenOnboardingResponseCode["ERROR"] = "ERROR";
    /** Card is blocked */
    PaymentsTokenOnboardingResponseCode["FORBIDDEN"] = "FORBIDDEN";
    /** Gift Card is not activated */
    PaymentsTokenOnboardingResponseCode["NOT_ACTIVATED"] = "NOT_ACTIVATED";
    /** Giftcard has no balance */
    PaymentsTokenOnboardingResponseCode["NO_BALANCE"] = "NO_BALANCE";
    /** Gift Card requires verification */
    PaymentsTokenOnboardingResponseCode["REQUIRE_ADDITIONAL_AUTHENTICATION"] = "REQUIRE_ADDITIONAL_AUTHENTICATION";
})(PaymentsTokenOnboardingResponseCode || (PaymentsTokenOnboardingResponseCode = {}));
/** PersonalPromotionErrorMessage */
export var PersonalPromotionErrorMessage;
(function (PersonalPromotionErrorMessage) {
    /** Bonus box has not yet been filled (can be the case when a new account is created and the offers are not yet available) */
    PersonalPromotionErrorMessage["BONUS_BOX_NOT_FILLED"] = "BONUS_BOX_NOT_FILLED";
    /** Generic error (for all other errors returned by the service) */
    PersonalPromotionErrorMessage["GENERIC"] = "GENERIC";
    /** Too early error message (for example if the user has selected order date in the far future where offers are to be determined) */
    PersonalPromotionErrorMessage["TOO_EARLY"] = "TOO_EARLY";
})(PersonalPromotionErrorMessage || (PersonalPromotionErrorMessage = {}));
/** Pickup location type code */
export var PickupLocationTypeCode;
(function (PickupLocationTypeCode) {
    /** Business to business */
    PickupLocationTypeCode["B2B"] = "B2B";
    /** Delivery point */
    PickupLocationTypeCode["DLP"] = "DLP";
    /** In store picking */
    PickupLocationTypeCode["ISP"] = "ISP";
    /** Store based full */
    PickupLocationTypeCode["SBF"] = "SBF";
    /** Store based light */
    PickupLocationTypeCode["SBL"] = "SBL";
    /** Specials only */
    PickupLocationTypeCode["SPO"] = "SPO";
    /** Stand alone */
    PickupLocationTypeCode["STA"] = "STA";
})(PickupLocationTypeCode || (PickupLocationTypeCode = {}));
/** availability status */
export var ProductAvailabilityStatus;
(function (ProductAvailabilityStatus) {
    /** available */
    ProductAvailabilityStatus["AVAILABLE"] = "AVAILABLE";
    /** available in the future */
    ProductAvailabilityStatus["FUTURE_ASSORTMENT"] = "FUTURE_ASSORTMENT";
    /** in assortment */
    ProductAvailabilityStatus["IN_ASSORTMENT"] = "IN_ASSORTMENT";
    /** not at this pickup point */
    ProductAvailabilityStatus["NOT_AT_THIS_PICKUP_POINT"] = "NOT_AT_THIS_PICKUP_POINT";
    /** not in assortment */
    ProductAvailabilityStatus["NOT_IN_ASSORTMENT"] = "NOT_IN_ASSORTMENT";
    /** offered from */
    ProductAvailabilityStatus["OFFERED_FROM"] = "OFFERED_FROM";
    /** no longer available */
    ProductAvailabilityStatus["OUT_OF_ASSORTMENT"] = "OUT_OF_ASSORTMENT";
    /** out of stock */
    ProductAvailabilityStatus["OUT_OF_STOCK"] = "OUT_OF_STOCK";
    /** will go out of assortment */
    ProductAvailabilityStatus["WILL_GO_OUT_OF_ASSORTMENT"] = "WILL_GO_OUT_OF_ASSORTMENT";
})(ProductAvailabilityStatus || (ProductAvailabilityStatus = {}));
/** availability status */
export var ProductCardAvailabilityStatus;
(function (ProductCardAvailabilityStatus) {
    /** available */
    ProductCardAvailabilityStatus["AVAILABLE"] = "AVAILABLE";
    /** available in the future */
    ProductCardAvailabilityStatus["FUTURE_ASSORTMENT"] = "FUTURE_ASSORTMENT";
    /** no longer available */
    ProductCardAvailabilityStatus["OUT_OF_ASSORTMENT"] = "OUT_OF_ASSORTMENT";
})(ProductCardAvailabilityStatus || (ProductCardAvailabilityStatus = {}));
/** Promotion type */
export var ProductCardBonusPromotionType;
(function (ProductCardBonusPromotionType) {
    /** Ah Online */
    ProductCardBonusPromotionType["AHONLINE"] = "AHONLINE";
    /** ETOS */
    ProductCardBonusPromotionType["ETOS"] = "ETOS";
    /** GALL */
    ProductCardBonusPromotionType["GALL"] = "GALL";
    /** GALLCARD */
    ProductCardBonusPromotionType["GALLCARD"] = "GALLCARD";
    /** Usually free delivery */
    ProductCardBonusPromotionType["INCENTIVE"] = "INCENTIVE";
    /** National */
    ProductCardBonusPromotionType["NATIONAL"] = "NATIONAL";
    /** Personal */
    ProductCardBonusPromotionType["PERSONAL"] = "PERSONAL";
    /**
     * Previously bought
     * @deprecated get it from the product search
     */
    ProductCardBonusPromotionType["PREVIOUSLY_BOUGHT"] = "PREVIOUSLY_BOUGHT";
    /**
     * Spotlight
     * @deprecated here is a spotlight argument on the query bonusSegments
     */
    ProductCardBonusPromotionType["SPOTLIGHT"] = "SPOTLIGHT";
})(ProductCardBonusPromotionType || (ProductCardBonusPromotionType = {}));
/** BonusSegmentType */
export var ProductCardBonusSegmentType;
(function (ProductCardBonusSegmentType) {
    /** AH stores */
    ProductCardBonusSegmentType["AH"] = "AH";
    /** AH online only */
    ProductCardBonusSegmentType["AH_ONLINE_ONLY"] = "AH_ONLINE_ONLY";
    /** AH online only subtype */
    ProductCardBonusSegmentType["AH_ONLINE_ONLY_SUBTYPE"] = "AH_ONLINE_ONLY_SUBTYPE";
    /** AH XL */
    ProductCardBonusSegmentType["AH_XL"] = "AH_XL";
    /** Bonus box */
    ProductCardBonusSegmentType["BONUS_BOX"] = "BONUS_BOX";
    /** BUNDEL */
    ProductCardBonusSegmentType["BUNDEL"] = "BUNDEL";
    /** Delivery bundle */
    ProductCardBonusSegmentType["DELIVERY_BUNDLE"] = "DELIVERY_BUNDLE";
    /** DIGITAL_SCRATCH_CARD */
    ProductCardBonusSegmentType["DIGITAL_SCRATCH_CARD"] = "DIGITAL_SCRATCH_CARD";
    /** Etos */
    ProductCardBonusSegmentType["ETOS"] = "ETOS";
    /** Free delivery */
    ProductCardBonusSegmentType["FREE_DELIVERY"] = "FREE_DELIVERY";
    /** Gall customer card and online */
    ProductCardBonusSegmentType["GALL_CUSTOMER_CARD"] = "GALL_CUSTOMER_CARD";
    /** Gall online only */
    ProductCardBonusSegmentType["GALL_ONLINE_ONLY"] = "GALL_ONLINE_ONLY";
    /** NEGATE_DIGITAL_SCRATCH_CARD */
    ProductCardBonusSegmentType["NEGATE_DIGITAL_SCRATCH_CARD"] = "NEGATE_DIGITAL_SCRATCH_CARD";
    /** NEGATE_PREMIUM */
    ProductCardBonusSegmentType["NEGATE_PREMIUM"] = "NEGATE_PREMIUM";
    /** Personal */
    ProductCardBonusSegmentType["PERSONAL_BONUS"] = "PERSONAL_BONUS";
    /** Premium */
    ProductCardBonusSegmentType["PREMIUM"] = "PREMIUM";
})(ProductCardBonusSegmentType || (ProductCardBonusSegmentType = {}));
/** Bonus Themes */
export var ProductCardBonusTheme;
(function (ProductCardBonusTheme) {
    /** Regular bonus */
    ProductCardBonusTheme["BONUS"] = "BONUS";
    /** Personal bonus */
    ProductCardBonusTheme["BONUS_BOX"] = "BONUS_BOX";
    /** Etos */
    ProductCardBonusTheme["ETOS"] = "ETOS";
    /** Gall'n'Gall */
    ProductCardBonusTheme["GALL"] = "GALL";
    /** Infinite */
    ProductCardBonusTheme["INFINITE"] = "INFINITE";
    /** Premium */
    ProductCardBonusTheme["PREMIUM"] = "PREMIUM";
    /** Tiered offer */
    ProductCardBonusTheme["TIERED_OFFER"] = "TIERED_OFFER";
})(ProductCardBonusTheme || (ProductCardBonusTheme = {}));
/** Possible product icons */
export var ProductCardIcon;
(function (ProductCardIcon) {
    /**
     * Available in store property
     * Temporarily used for availability label on mobile
     */
    ProductCardIcon["AVAILABLE_IN_STORE"] = "AVAILABLE_IN_STORE";
    /** Bake off */
    ProductCardIcon["BAKE_OFF"] = "BAKE_OFF";
    /** Discount pack */
    ProductCardIcon["DISCOUNT_PACK"] = "DISCOUNT_PACK";
    /** Frozen */
    ProductCardIcon["FROZEN"] = "FROZEN";
    /** Locally produced */
    ProductCardIcon["LOCALLY_PRODUCED"] = "LOCALLY_PRODUCED";
    /** New */
    ProductCardIcon["NEW"] = "NEW";
    /** Nutri-score A */
    ProductCardIcon["NUTRISCORE_A"] = "NUTRISCORE_A";
    /** Nutri-score B */
    ProductCardIcon["NUTRISCORE_B"] = "NUTRISCORE_B";
    /** Nutri-score C */
    ProductCardIcon["NUTRISCORE_C"] = "NUTRISCORE_C";
    /** Nutri-score D */
    ProductCardIcon["NUTRISCORE_D"] = "NUTRISCORE_D";
    /** Nutri-score E */
    ProductCardIcon["NUTRISCORE_E"] = "NUTRISCORE_E";
    /** Organic */
    ProductCardIcon["ORGANIC"] = "ORGANIC";
    /** Price favorite */
    ProductCardIcon["PRICE_FAVORITE"] = "PRICE_FAVORITE";
    /** Prize winner */
    ProductCardIcon["PRIZE_WINNER"] = "PRIZE_WINNER";
    /** Vega */
    ProductCardIcon["VEGAN"] = "VEGAN";
    /** Vegetarion */
    ProductCardIcon["VEGETARIAN"] = "VEGETARIAN";
    /** XL store */
    ProductCardIcon["XL_STORE"] = "XL_STORE";
})(ProductCardIcon || (ProductCardIcon = {}));
/** What angles are available for a product image */
export var ProductCardImageAngle;
(function (ProductCardImageAngle) {
    /** packshot voorkant / packshot frontside */
    ProductCardImageAngle["ANGLE_2D1"] = "ANGLE_2D1";
    /** A multi-angle image */
    ProductCardImageAngle["ANGLE_4D1"] = "ANGLE_4D1";
    /** A multi-angle image */
    ProductCardImageAngle["ANGLE_4D2"] = "ANGLE_4D2";
    /** A multi-angle image */
    ProductCardImageAngle["ANGLE_4D3"] = "ANGLE_4D3";
    /** A multi-angle image */
    ProductCardImageAngle["ANGLE_4D4"] = "ANGLE_4D4";
    /** A multi-angle image */
    ProductCardImageAngle["ANGLE_4D5"] = "ANGLE_4D5";
    /** A multi-angle image */
    ProductCardImageAngle["ANGLE_4D6"] = "ANGLE_4D6";
    /** A multi-angle image */
    ProductCardImageAngle["ANGLE_4D7"] = "ANGLE_4D7";
    /** A multi-angle image */
    ProductCardImageAngle["ANGLE_5D1"] = "ANGLE_5D1";
    /** A multi-angle image */
    ProductCardImageAngle["ANGLE_5D2"] = "ANGLE_5D2";
    /** A multi-angle image */
    ProductCardImageAngle["ANGLE_5D3"] = "ANGLE_5D3";
    /** The hero image. To be used on the product detail page. */
    ProductCardImageAngle["HERO"] = "HERO";
})(ProductCardImageAngle || (ProductCardImageAngle = {}));
/** Possible product shop types */
export var ProductCardShopType;
(function (ProductCardShopType) {
    /** Albert Heijn shop */
    ProductCardShopType["AH"] = "AH";
    /** Etos shop */
    ProductCardShopType["ET"] = "ET";
    /** Gall shop */
    ProductCardShopType["GA"] = "GA";
})(ProductCardShopType || (ProductCardShopType = {}));
/** Product complaint claim status */
export var ProductComplaintClaimStatus;
(function (ProductComplaintClaimStatus) {
    /** The order contains products that can be claimed */
    ProductComplaintClaimStatus["CLAIMABLE"] = "CLAIMABLE";
    /** Maximum products in this order have been claimed */
    ProductComplaintClaimStatus["MAX_CLAIMED"] = "MAX_CLAIMED";
})(ProductComplaintClaimStatus || (ProductComplaintClaimStatus = {}));
/** Product complaint shopping type */
export var ProductComplaintShoppingType;
(function (ProductComplaintShoppingType) {
    /** Delivery */
    ProductComplaintShoppingType["DELIVERY"] = "DELIVERY";
    /** Delivery point */
    ProductComplaintShoppingType["DELIVERY_POINT"] = "DELIVERY_POINT";
    /** In-store pick */
    ProductComplaintShoppingType["IN_STORE_PICK"] = "IN_STORE_PICK";
    /** Physical store */
    ProductComplaintShoppingType["PHYSICAL_STORE"] = "PHYSICAL_STORE";
    /** Pickup */
    ProductComplaintShoppingType["PICKUP"] = "PICKUP";
    /** Pickup delivery */
    ProductComplaintShoppingType["PICKUP_DELIVERY"] = "PICKUP_DELIVERY";
    /** Specials only */
    ProductComplaintShoppingType["SPECIALS_ONLY"] = "SPECIALS_ONLY";
    /** Unknown */
    ProductComplaintShoppingType["UNKNOWN"] = "UNKNOWN";
})(ProductComplaintShoppingType || (ProductComplaintShoppingType = {}));
/** Possible product icons */
export var ProductIcon;
(function (ProductIcon) {
    /**
     * Available in store property
     * Temporarily used for availability label on mobile
     */
    ProductIcon["AVAILABLE_IN_STORE"] = "AVAILABLE_IN_STORE";
    /** Bake off */
    ProductIcon["BAKE_OFF"] = "BAKE_OFF";
    /** Discount pack */
    ProductIcon["DISCOUNT_PACK"] = "DISCOUNT_PACK";
    /** Frozen */
    ProductIcon["FROZEN"] = "FROZEN";
    /** Locally produced */
    ProductIcon["LOCALLY_PRODUCED"] = "LOCALLY_PRODUCED";
    /** New */
    ProductIcon["NEW"] = "NEW";
    /** Nutri-score A */
    ProductIcon["NUTRISCORE_A"] = "NUTRISCORE_A";
    /** Nutri-score B */
    ProductIcon["NUTRISCORE_B"] = "NUTRISCORE_B";
    /** Nutri-score C */
    ProductIcon["NUTRISCORE_C"] = "NUTRISCORE_C";
    /** Nutri-score D */
    ProductIcon["NUTRISCORE_D"] = "NUTRISCORE_D";
    /** Nutri-score E */
    ProductIcon["NUTRISCORE_E"] = "NUTRISCORE_E";
    /** Organic */
    ProductIcon["ORGANIC"] = "ORGANIC";
    /** Price favorite */
    ProductIcon["PRICE_FAVORITE"] = "PRICE_FAVORITE";
    /** Prize winner */
    ProductIcon["PRIZE_WINNER"] = "PRIZE_WINNER";
    /** Vega */
    ProductIcon["VEGAN"] = "VEGAN";
    /** Vegetarion */
    ProductIcon["VEGETARIAN"] = "VEGETARIAN";
    /** XL store */
    ProductIcon["XL_STORE"] = "XL_STORE";
})(ProductIcon || (ProductIcon = {}));
/** What angles are available for a product image */
export var ProductImageAngle;
(function (ProductImageAngle) {
    /** packshot voorkant / packshot frontside */
    ProductImageAngle["ANGLE_2D1"] = "ANGLE_2D1";
    /** A multi-angle image */
    ProductImageAngle["ANGLE_4D1"] = "ANGLE_4D1";
    /** A multi-angle image */
    ProductImageAngle["ANGLE_4D2"] = "ANGLE_4D2";
    /** A multi-angle image */
    ProductImageAngle["ANGLE_4D3"] = "ANGLE_4D3";
    /** A multi-angle image */
    ProductImageAngle["ANGLE_4D4"] = "ANGLE_4D4";
    /** A multi-angle image */
    ProductImageAngle["ANGLE_4D5"] = "ANGLE_4D5";
    /** A multi-angle image */
    ProductImageAngle["ANGLE_4D6"] = "ANGLE_4D6";
    /** A multi-angle image */
    ProductImageAngle["ANGLE_4D7"] = "ANGLE_4D7";
    /** A multi-angle image */
    ProductImageAngle["ANGLE_5D1"] = "ANGLE_5D1";
    /** A multi-angle image */
    ProductImageAngle["ANGLE_5D2"] = "ANGLE_5D2";
    /** A multi-angle image */
    ProductImageAngle["ANGLE_5D3"] = "ANGLE_5D3";
    /** The hero image. To be used on the product detail page. */
    ProductImageAngle["HERO"] = "HERO";
})(ProductImageAngle || (ProductImageAngle = {}));
/**
 * Image renditions returned by the product image processor
 * in the form of D<width>x<height>
 */
export var ProductImageRenditions;
(function (ProductImageRenditions) {
    /** width: 200, height: 200 */
    ProductImageRenditions["D200X200"] = "D200X200";
    /** width: 400, height: 400 */
    ProductImageRenditions["D400X400"] = "D400X400";
    /** width: 800, height: 800 */
    ProductImageRenditions["D800X800"] = "D800X800";
})(ProductImageRenditions || (ProductImageRenditions = {}));
/** Possible product property icons */
export var ProductPropertyIcon;
(function (ProductPropertyIcon) {
    /** Bake off */
    ProductPropertyIcon["BAKE_OFF"] = "BAKE_OFF";
    /** Discount pack */
    ProductPropertyIcon["DISCOUNT_PACK"] = "DISCOUNT_PACK";
    /** Frozen */
    ProductPropertyIcon["FROZEN"] = "FROZEN";
    /** Locally produced */
    ProductPropertyIcon["LOCALLY_PRODUCED"] = "LOCALLY_PRODUCED";
    /** New */
    ProductPropertyIcon["NEW"] = "NEW";
    /** Organic */
    ProductPropertyIcon["ORGANIC"] = "ORGANIC";
    /** Price favorite */
    ProductPropertyIcon["PRICE_FAVORITE"] = "PRICE_FAVORITE";
    /** Prize winner */
    ProductPropertyIcon["PRIZE_WINNER"] = "PRIZE_WINNER";
    /** Vega */
    ProductPropertyIcon["VEGAN"] = "VEGAN";
    /** Vegetarion */
    ProductPropertyIcon["VEGETARIAN"] = "VEGETARIAN";
    /** XL store */
    ProductPropertyIcon["XL_STORE"] = "XL_STORE";
})(ProductPropertyIcon || (ProductPropertyIcon = {}));
/** Explanation types */
export var ProductReturnExplanationType;
(function (ProductReturnExplanationType) {
    /** Product cannot be returned */
    ProductReturnExplanationType["CANNOT_BE_RETURNED"] = "CANNOT_BE_RETURNED";
    /** Product is excluded from self service */
    ProductReturnExplanationType["EXCLUDED_FROM_SELF_SERVICE"] = "EXCLUDED_FROM_SELF_SERVICE";
    /** Product was not delivered */
    ProductReturnExplanationType["NOT_DELIVERED"] = "NOT_DELIVERED";
    /** Return is procesed */
    ProductReturnExplanationType["PROCESSED"] = "PROCESSED";
    /** Product return is settled by deliverer */
    ProductReturnExplanationType["SETTLED_BY_DELIVERER"] = "SETTLED_BY_DELIVERER";
    /** Product is submited for return */
    ProductReturnExplanationType["SUBMITTED"] = "SUBMITTED";
})(ProductReturnExplanationType || (ProductReturnExplanationType = {}));
/** Shopping type of the order */
export var ProductReturnShoppingType;
(function (ProductReturnShoppingType) {
    /** delivery */
    ProductReturnShoppingType["DELIVERY"] = "DELIVERY";
    /** delivery point */
    ProductReturnShoppingType["DELIVERY_POINT"] = "DELIVERY_POINT";
    /** in store pick */
    ProductReturnShoppingType["IN_STORE_PICK"] = "IN_STORE_PICK";
    /** store */
    ProductReturnShoppingType["PHYSICAL_STORE"] = "PHYSICAL_STORE";
    /** pickup */
    ProductReturnShoppingType["PICKUP"] = "PICKUP";
    /** pickup delivery */
    ProductReturnShoppingType["PICKUP_DELIVERY"] = "PICKUP_DELIVERY";
    /** specials only */
    ProductReturnShoppingType["SPECIALS_ONLY"] = "SPECIALS_ONLY";
    /** unkown */
    ProductReturnShoppingType["UNKNOWN"] = "UNKNOWN";
})(ProductReturnShoppingType || (ProductReturnShoppingType = {}));
/** Status of the order for product-returns */
export var ProductReturnStatus;
(function (ProductReturnStatus) {
    /** Maximum products in this order have been returned */
    ProductReturnStatus["MAX_RETURNED"] = "MAX_RETURNED";
    /** The order and its products cannot be returned */
    ProductReturnStatus["NOT_POSSIBLE"] = "NOT_POSSIBLE";
    /** The order contains products that can be returned */
    ProductReturnStatus["RETURNABLE"] = "RETURNABLE";
})(ProductReturnStatus || (ProductReturnStatus = {}));
/** Possible product shop types */
export var ProductShopType;
(function (ProductShopType) {
    /** Albert Heijn shop */
    ProductShopType["AH"] = "AH";
    /** Etos shop */
    ProductShopType["ET"] = "ET";
    /** Gall shop */
    ProductShopType["GA"] = "GA";
})(ProductShopType || (ProductShopType = {}));
/** Communication channel type */
export var ProductTradeItemCommunicationChannelType;
(function (ProductTradeItemCommunicationChannelType) {
    /** Email */
    ProductTradeItemCommunicationChannelType["EMAIL"] = "EMAIL";
    /** Fax */
    ProductTradeItemCommunicationChannelType["FAX"] = "FAX";
    /** Social media */
    ProductTradeItemCommunicationChannelType["SOCIAL_MEDIA"] = "SOCIAL_MEDIA";
    /** Telephone */
    ProductTradeItemCommunicationChannelType["TELEPHONE"] = "TELEPHONE";
    /** Website */
    ProductTradeItemCommunicationChannelType["WEBSITE"] = "WEBSITE";
})(ProductTradeItemCommunicationChannelType || (ProductTradeItemCommunicationChannelType = {}));
/** Resource icon type */
export var ProductTradeItemResourceIconType;
(function (ProductTradeItemResourceIconType) {
    /** Additional */
    ProductTradeItemResourceIconType["ADDITIONAL"] = "ADDITIONAL";
    /** Danger */
    ProductTradeItemResourceIconType["DANGER"] = "DANGER";
    /** Diet allergen */
    ProductTradeItemResourceIconType["DIET_ALLERGEN"] = "DIET_ALLERGEN";
    /** Free from */
    ProductTradeItemResourceIconType["FREE_FROM"] = "FREE_FROM";
    /** Registered */
    ProductTradeItemResourceIconType["REGISTERED"] = "REGISTERED";
    /** Regulated */
    ProductTradeItemResourceIconType["REGULATED"] = "REGULATED";
})(ProductTradeItemResourceIconType || (ProductTradeItemResourceIconType = {}));
/** reason why the product is unavailable */
export var ProductUnavailableReason;
(function (ProductUnavailableReason) {
    /** product will come available but is not yet available */
    ProductUnavailableReason["FUTURE_ASSORTMENT"] = "FUTURE_ASSORTMENT";
    /** product is for pickup but not for this location */
    ProductUnavailableReason["NOT_AT_THIS_PICKUP_POINT"] = "NOT_AT_THIS_PICKUP_POINT";
    /** product is not for pickup */
    ProductUnavailableReason["NOT_FOR_PICKUP"] = "NOT_FOR_PICKUP";
    /** product is not longer availabile (online) */
    ProductUnavailableReason["NO_LONGER_ONLINE"] = "NO_LONGER_ONLINE";
    /** product is not longer availabile (online and offline) */
    ProductUnavailableReason["OUT_OF_ASSORTMENT"] = "OUT_OF_ASSORTMENT";
    /** product is not availability online */
    ProductUnavailableReason["SHOP_ONLY"] = "SHOP_ONLY";
    /** product is sold out */
    ProductUnavailableReason["SOLD_OUT"] = "SOLD_OUT";
})(ProductUnavailableReason || (ProductUnavailableReason = {}));
/** Product variant type */
export var ProductVariantType;
(function (ProductVariantType) {
    /** Primary type (the bottle of wine) */
    ProductVariantType["PRIMARY"] = "PRIMARY";
    /** Secondary type (the case of bottles of wine) */
    ProductVariantType["SECONDARY"] = "SECONDARY";
})(ProductVariantType || (ProductVariantType = {}));
/** Promotion Label Type */
export var PromotionLabelType;
(function (PromotionLabelType) {
    /** AIRMILES */
    PromotionLabelType["AIRMILES"] = "AIRMILES";
    /** B2B_PREMIUM */
    PromotionLabelType["B2B_PREMIUM"] = "B2B_PREMIUM";
    /** BONUS_BOX */
    PromotionLabelType["BONUS_BOX"] = "BONUS_BOX";
    /** DELIVERY_BUNDLE */
    PromotionLabelType["DELIVERY_BUNDLE"] = "DELIVERY_BUNDLE";
    /** ETOS */
    PromotionLabelType["ETOS"] = "ETOS";
    /** FREE_DELIVERY */
    PromotionLabelType["FREE_DELIVERY"] = "FREE_DELIVERY";
    /** GALL_PREMIUM */
    PromotionLabelType["GALL_PREMIUM"] = "GALL_PREMIUM";
    /** NO_DISCOUNT_BUNDLE */
    PromotionLabelType["NO_DISCOUNT_BUNDLE"] = "NO_DISCOUNT_BUNDLE";
    /** ONLINE */
    PromotionLabelType["ONLINE"] = "ONLINE";
    /** PERSONAL_OFFER */
    PromotionLabelType["PERSONAL_OFFER"] = "PERSONAL_OFFER";
    /** PREMIUM */
    PromotionLabelType["PREMIUM"] = "PREMIUM";
    /** PRODUCT_DISCOUNT_BUNDLE */
    PromotionLabelType["PRODUCT_DISCOUNT_BUNDLE"] = "PRODUCT_DISCOUNT_BUNDLE";
    /** SCRATCH_SUMMER */
    PromotionLabelType["SCRATCH_SUMMER"] = "SCRATCH_SUMMER";
    /** SPOTLIGHT */
    PromotionLabelType["SPOTLIGHT"] = "SPOTLIGHT";
})(PromotionLabelType || (PromotionLabelType = {}));
/** Enum containing all the types of migration status. */
export var PurchaseStampMigrationStatus;
(function (PurchaseStampMigrationStatus) {
    /**
     * The status indicating that a member is partially migrated. Their balance is already
     * available, but the transaction history is still being migrated.
     */
    PurchaseStampMigrationStatus["BALANCE_MIGRATED"] = "BALANCE_MIGRATED";
    /** The status indicating that a member has been fully migrated. */
    PurchaseStampMigrationStatus["COMPLETED"] = "COMPLETED";
    /**
     * The status indicating that a member is being migrated at the moment. Their balance and
     * transaction history is not available.
     */
    PurchaseStampMigrationStatus["IN_PROGRESS"] = "IN_PROGRESS";
    /** The status indicating that a member has yet to be migrated. */
    PurchaseStampMigrationStatus["NOT_MIGRATED"] = "NOT_MIGRATED";
})(PurchaseStampMigrationStatus || (PurchaseStampMigrationStatus = {}));
/** Enum that represents type of the device that performs the mutation */
export var PushNotificationsDeviceType;
(function (PushNotificationsDeviceType) {
    PushNotificationsDeviceType["ANDROID"] = "ANDROID";
    PushNotificationsDeviceType["IOS"] = "IOS";
})(PushNotificationsDeviceType || (PushNotificationsDeviceType = {}));
/** Indicates what kind of stock the quantity displays */
export var QuantityType;
(function (QuantityType) {
    /** Amount in pieces */
    QuantityType["PIECE"] = "PIECE";
    /** Amount in weight */
    QuantityType["WEIGHT"] = "WEIGHT";
})(QuantityType || (QuantityType = {}));
/** The quote image alignment (left/right) */
export var QuoteImageAlignmentType;
(function (QuoteImageAlignmentType) {
    QuoteImageAlignmentType["LEFT"] = "LEFT";
    QuoteImageAlignmentType["RIGHT"] = "RIGHT";
})(QuoteImageAlignmentType || (QuoteImageAlignmentType = {}));
/** Recipe flags indicating presence of certain tags, internalTags or classifications */
export var RecipeFlag;
(function (RecipeFlag) {
    /** Gluten free flag */
    RecipeFlag["GLUTEN_FREE"] = "GLUTEN_FREE";
    /** Keto flag */
    RecipeFlag["KETO"] = "KETO";
    /** Lactose free flag */
    RecipeFlag["LACTOSE_FREE"] = "LACTOSE_FREE";
    /** Low calories flag */
    RecipeFlag["LOW_CALORIES"] = "LOW_CALORIES";
    /** Low carbs flag */
    RecipeFlag["LOW_CARBS"] = "LOW_CARBS";
    /** Protein rich flag */
    RecipeFlag["PROTEIN_RICH"] = "PROTEIN_RICH";
})(RecipeFlag || (RecipeFlag = {}));
/** Recipe nutri-score */
export var RecipeNutriScore;
(function (RecipeNutriScore) {
    RecipeNutriScore["A"] = "A";
    RecipeNutriScore["B"] = "B";
    RecipeNutriScore["C"] = "C";
    RecipeNutriScore["D"] = "D";
    RecipeNutriScore["E"] = "E";
})(RecipeNutriScore || (RecipeNutriScore = {}));
/** Recipe origin type enum */
export var RecipeOriginType;
(function (RecipeOriginType) {
    /** Allerhande recipe */
    RecipeOriginType["ALLERHANDE"] = "ALLERHANDE";
    /** FFN recipe */
    RecipeOriginType["FFN"] = "FFN";
    /** Member created recipe */
    RecipeOriginType["MEMBER_CREATED"] = "MEMBER_CREATED";
    /** Member scraped recipe */
    RecipeOriginType["MEMBER_SCRAPED"] = "MEMBER_SCRAPED";
    /** Orphaned recipe */
    RecipeOriginType["ORPHANED"] = "ORPHANED";
    /** Sponsored recipe */
    RecipeOriginType["SPONSORED"] = "SPONSORED";
})(RecipeOriginType || (RecipeOriginType = {}));
/** Sorting options for recipe search query */
export var RecipeSearchSortOption;
(function (RecipeSearchSortOption) {
    /** Sorted by relevancy */
    RecipeSearchSortOption["MOST_RELEVANT"] = "MOST_RELEVANT";
    /** Sorted by newest */
    RecipeSearchSortOption["NEWEST"] = "NEWEST";
    /** Sorted by most popular */
    RecipeSearchSortOption["POPULAR"] = "POPULAR";
    /** Sorted by most rated */
    RecipeSearchSortOption["RATINGS"] = "RATINGS";
    /** Sorted by preparation time */
    RecipeSearchSortOption["TOTAL_TIME"] = "TOTAL_TIME";
    /** Sorted by trending */
    RecipeSearchSortOption["TRENDING"] = "TRENDING";
})(RecipeSearchSortOption || (RecipeSearchSortOption = {}));
/** Product suggestion proposer */
export var RecipeShoppableProductSuggestionProposer;
(function (RecipeShoppableProductSuggestionProposer) {
    /** Albert Heijn */
    RecipeShoppableProductSuggestionProposer["A"] = "A";
    /** Bonus recipe */
    RecipeShoppableProductSuggestionProposer["BONUS_RECIPE"] = "BONUS_RECIPE";
    /** North Fork */
    RecipeShoppableProductSuggestionProposer["N"] = "N";
    /** Product Search */
    RecipeShoppableProductSuggestionProposer["PRODUCT_SEARCH"] = "PRODUCT_SEARCH";
    /** Search override */
    RecipeShoppableProductSuggestionProposer["SEARCH_OVERRIDE"] = "SEARCH_OVERRIDE";
    /** Semantic Model */
    RecipeShoppableProductSuggestionProposer["SEMANTIC_MODEL"] = "SEMANTIC_MODEL";
    /** Sponsored Product */
    RecipeShoppableProductSuggestionProposer["SPONSORED_PRODUCT"] = "SPONSORED_PRODUCT";
})(RecipeShoppableProductSuggestionProposer || (RecipeShoppableProductSuggestionProposer = {}));
/** Selection type enum. Specifies whether ingredient to product mapping was added, changed or removed */
export var RecipeShoppableSelectionAction;
(function (RecipeShoppableSelectionAction) {
    /** ADD */
    RecipeShoppableSelectionAction["ADD"] = "ADD";
    /** CHANGE */
    RecipeShoppableSelectionAction["CHANGE"] = "CHANGE";
    /** REMOVE */
    RecipeShoppableSelectionAction["REMOVE"] = "REMOVE";
})(RecipeShoppableSelectionAction || (RecipeShoppableSelectionAction = {}));
/** Mapping proposer. Specifies the provider of ingredient to product mapping */
export var RecipeShoppableSelectionProductProposer;
(function (RecipeShoppableSelectionProductProposer) {
    /** Albert Heijn */
    RecipeShoppableSelectionProductProposer["A"] = "A";
    /** Bonus recipe proposer */
    RecipeShoppableSelectionProductProposer["BONUS_RECIPE"] = "BONUS_RECIPE";
    /** North Fork */
    RecipeShoppableSelectionProductProposer["N"] = "N";
    /** Product Search */
    RecipeShoppableSelectionProductProposer["PRODUCT_SEARCH"] = "PRODUCT_SEARCH";
    /** Search override */
    RecipeShoppableSelectionProductProposer["SEARCH_OVERRIDE"] = "SEARCH_OVERRIDE";
    /** Semantic Model */
    RecipeShoppableSelectionProductProposer["SEMANTIC_MODEL"] = "SEMANTIC_MODEL";
    /** Sponsored Product */
    RecipeShoppableSelectionProductProposer["SPONSORED_PRODUCT"] = "SPONSORED_PRODUCT";
})(RecipeShoppableSelectionProductProposer || (RecipeShoppableSelectionProductProposer = {}));
/** Recipe source type enum */
export var RecipeSourceType;
(function (RecipeSourceType) {
    /** Allerhande recipe */
    RecipeSourceType["ALLERHANDE_RECIPE"] = "ALLERHANDE_RECIPE";
    /** Member created recipe */
    RecipeSourceType["MEMBER_RECIPE"] = "MEMBER_RECIPE";
})(RecipeSourceType || (RecipeSourceType = {}));
/** Recipe story theme enum */
export var RecipeStoryCollectionTheme;
(function (RecipeStoryCollectionTheme) {
    /** Christmas theme */
    RecipeStoryCollectionTheme["CHRISTMAS"] = "CHRISTMAS";
    /** Default theme (i.e.: no theme) */
    RecipeStoryCollectionTheme["DEFAULT"] = "DEFAULT";
    /** Prijsfavorieten theme */
    RecipeStoryCollectionTheme["PRIJSFAVORIETEN"] = "PRIJSFAVORIETEN";
})(RecipeStoryCollectionTheme || (RecipeStoryCollectionTheme = {}));
/** Enum thats contains all type of recipeStories */
export var RecipeStoryCollectionType;
(function (RecipeStoryCollectionType) {
    /** Bonus */
    RecipeStoryCollectionType["BONUS"] = "BONUS";
    /** Flex Page */
    RecipeStoryCollectionType["FLEX_PAGE"] = "FLEX_PAGE";
    /** Product Bundle */
    RecipeStoryCollectionType["PRODUCTS"] = "PRODUCTS";
    /** Recipe */
    RecipeStoryCollectionType["RECIPE"] = "RECIPE";
})(RecipeStoryCollectionType || (RecipeStoryCollectionType = {}));
/** Enum that contains all types of recipeStoryItems */
export var RecipeStoryItemType;
(function (RecipeStoryItemType) {
    /** Flex Page */
    RecipeStoryItemType["FLEX_PAGE"] = "FLEX_PAGE";
    /** Product Bundle */
    RecipeStoryItemType["PRODUCTS"] = "PRODUCTS";
    /** Recipe */
    RecipeStoryItemType["RECIPE"] = "RECIPE";
})(RecipeStoryItemType || (RecipeStoryItemType = {}));
/** Sorting options for recipe search query */
export var RecipeVideoSearchSortOption;
(function (RecipeVideoSearchSortOption) {
    /** Sorted by alphabet */
    RecipeVideoSearchSortOption["ALPHABETIC"] = "ALPHABETIC";
    /** Sorted by duration */
    RecipeVideoSearchSortOption["DURATION"] = "DURATION";
    /** Sorted by newest */
    RecipeVideoSearchSortOption["LATEST"] = "LATEST";
    /** Sorted by relevancy */
    RecipeVideoSearchSortOption["MOST_RELEVANT"] = "MOST_RELEVANT";
    /** Sorted by views count */
    RecipeVideoSearchSortOption["MOST_VIEWED"] = "MOST_VIEWED";
})(RecipeVideoSearchSortOption || (RecipeVideoSearchSortOption = {}));
/** Render type */
export var RenderType;
(function (RenderType) {
    RenderType["MARKETING_CAROUSEL"] = "MARKETING_CAROUSEL";
    RenderType["SUPERSHOPS"] = "SUPERSHOPS";
    RenderType["UNKNOWN"] = "UNKNOWN";
})(RenderType || (RenderType = {}));
/** Recipe image rendition keys enum. See graphQlKey = backendKey */
export var RenditionKey;
(function (RenditionKey) {
    /** Graphql d220x162 key corresponds to backend '210x118_JPG' key */
    RenditionKey["D210X118"] = "D210X118";
    /** Graphql d220x162 key corresponds to backend '220x162_JPG' key */
    RenditionKey["D220X162"] = "D220X162";
    /** Graphql d256x256 key corresponds to backend '256x256_PNG' key */
    RenditionKey["D256X256_PNG"] = "D256X256_PNG";
    /** Graphql d302x220 key corresponds to backend '302x220_JPG' key */
    RenditionKey["D302X220"] = "D302X220";
    /** Graphql d420x236 key corresponds to backend '420x236_JPG' key */
    RenditionKey["D420X236"] = "D420X236";
    /** Graphql d440x324 key corresponds to backend '440x324_JPG' key */
    RenditionKey["D440X324"] = "D440X324";
    /** Graphql d445x297 key corresponds to backend '445x297_JPG' key */
    RenditionKey["D445X297"] = "D445X297";
    /** Graphql d612x450 key corresponds to backend '612x450_JPG' key */
    RenditionKey["D612X450"] = "D612X450";
    /** Graphql d680x320 key corresponds to backend '680x320_JPG' key */
    RenditionKey["D680X320"] = "D680X320";
    /** Graphql d890x594 key corresponds to backend '890x594_JPG' key */
    RenditionKey["D890X594"] = "D890X594";
    /** Graphql d1024x576 key corresponds to backend '1024x576_JPG' key */
    RenditionKey["D1024X576"] = "D1024X576";
    /** Graphql d1024x748 key corresponds to backend '1024x748_JPG' key */
    RenditionKey["D1024X748"] = "D1024X748";
    /** Graphql d1224x900 key corresponds to backend '1224x900_JPG' key */
    RenditionKey["D1224X900"] = "D1224X900";
    /** Graphql d1600x560 key corresponds to backend '1600x560_JPG' key */
    RenditionKey["D1600X560"] = "D1600X560";
    /** Graphql d1920x1080 key corresponds to backend '1920x1080_JPG' key */
    RenditionKey["D1920X1080"] = "D1920X1080";
    /** Graphql d2048x1152 key corresponds to backend '2048x1152_JPG' key */
    RenditionKey["D2048X1152"] = "D2048X1152";
    /** Graphql d2048x1496 key corresponds to backend '2048x1496_JPG' key */
    RenditionKey["D2048X1496"] = "D2048X1496";
    /** Graphql l key corresponds to backend 'L' key */
    RenditionKey["L"] = "L";
    /** Graphql m key corresponds to backend 'M' key */
    RenditionKey["M"] = "M";
    /** Graphql s key corresponds to backend 'S' key */
    RenditionKey["S"] = "S";
    /** Graphql xl key corresponds to backend 'XL' key */
    RenditionKey["XL"] = "XL";
    /** Graphql xs key corresponds to backend 'XS' key */
    RenditionKey["XS"] = "XS";
    /** Graphql xxs key corresponds to backend 'XXS' key */
    RenditionKey["XXS"] = "XXS";
})(RenditionKey || (RenditionKey = {}));
/** Possible facet types */
export var SearchFacetType;
(function (SearchFacetType) {
    /** Facet type that has conformance to value/values in a hierarchical order */
    SearchFacetType["HIERARCHY"] = "HIERARCHY";
    /** Facet type that has conformance to multiple values */
    SearchFacetType["MULTIPLE"] = "MULTIPLE";
    /** Facet type that has conformance to a range */
    SearchFacetType["RANGE"] = "RANGE";
    /** Facet type that has conformance to a single value */
    SearchFacetType["SINGLE"] = "SINGLE";
})(SearchFacetType || (SearchFacetType = {}));
/** Possible search products intent types */
export var SearchIntentType;
(function (SearchIntentType) {
    /** Intent type for product browsing */
    SearchIntentType["BROWSE"] = "BROWSE";
    /** Intent type for ordering online */
    SearchIntentType["ONLINE"] = "ONLINE";
    /** Intent type for store order */
    SearchIntentType["STORE"] = "STORE";
})(SearchIntentType || (SearchIntentType = {}));
/** Possible previously bought sorting types */
export var SearchPreviouslyBoughtSortType;
(function (SearchPreviouslyBoughtSortType) {
    /** Sorting type based on product NUTRI-SCORE */
    SearchPreviouslyBoughtSortType["NUTRI_SCORE_A_E"] = "NUTRI_SCORE_A_E";
    /** Sorting type based on PURCHASE_DATE */
    SearchPreviouslyBoughtSortType["PURCHASE_DATE"] = "PURCHASE_DATE";
    /** Sorting type based on how FREQUENT a product is purchased */
    SearchPreviouslyBoughtSortType["PURCHASE_FREQUENCY"] = "PURCHASE_FREQUENCY";
    /** Sorting type based on product TAXONOMY */
    SearchPreviouslyBoughtSortType["PURCHASE_TAXONOMY"] = "PURCHASE_TAXONOMY";
})(SearchPreviouslyBoughtSortType || (SearchPreviouslyBoughtSortType = {}));
/** Possible sorting types for search */
export var SearchProductsSortType;
(function (SearchProductsSortType) {
    /** Sorting type based on product NUTRI-SCORE */
    SearchProductsSortType["NUTRI_SCORE_A_E"] = "NUTRI_SCORE_A_E";
    /** Sorting type based on product price, from HIGH to LOW */
    SearchProductsSortType["PRICE_HIGH_LOW"] = "PRICE_HIGH_LOW";
    /** Sorting type based on product price, from LOW to HIGH */
    SearchProductsSortType["PRICE_LOW_HIGH"] = "PRICE_LOW_HIGH";
    /** Sorting type based on product RELEVANCE */
    SearchProductsSortType["RELEVANCE"] = "RELEVANCE";
})(SearchProductsSortType || (SearchProductsSortType = {}));
/** Suggestion types for search. */
export var SearchSuggestionType;
(function (SearchSuggestionType) {
    /** Default suggestion type. */
    SearchSuggestionType["DEFAULT"] = "DEFAULT";
    /** Suggestion which functions as a link to view more results. */
    SearchSuggestionType["MORE_LINK"] = "MORE_LINK";
    /** Suggestion for when there are no results found. */
    SearchSuggestionType["NO_RESULT"] = "NO_RESULT";
    /** The section of the suggestions, eg. products, recipes or customer care. */
    SearchSuggestionType["SECTION"] = "SECTION";
})(SearchSuggestionType || (SearchSuggestionType = {}));
/** CostOverviewSettlement Item type */
export var SettlementAfterDeliveryType;
(function (SettlementAfterDeliveryType) {
    /** Deposits */
    SettlementAfterDeliveryType["DEPOSIT"] = "DEPOSIT";
    /** Item (DEFAULT) */
    SettlementAfterDeliveryType["ITEM"] = "ITEM";
    /** Restitution (Money back) */
    SettlementAfterDeliveryType["RESTITUTION"] = "RESTITUTION";
    /** Service memo */
    SettlementAfterDeliveryType["SERVICE_MEMO"] = "SERVICE_MEMO";
})(SettlementAfterDeliveryType || (SettlementAfterDeliveryType = {}));
/** Settlement refund method */
export var SettlementRefundMethod;
(function (SettlementRefundMethod) {
    /** BANK */
    SettlementRefundMethod["BANK"] = "BANK";
    /** DELIVERER */
    SettlementRefundMethod["DELIVERER"] = "DELIVERER";
    /** EVALUE */
    SettlementRefundMethod["EVALUE"] = "EVALUE";
    /** INVOICE */
    SettlementRefundMethod["INVOICE"] = "INVOICE";
    /** NO_REFUND */
    SettlementRefundMethod["NO_REFUND"] = "NO_REFUND";
})(SettlementRefundMethod || (SettlementRefundMethod = {}));
/** Settlement feedback type */
export var SettlementType;
(function (SettlementType) {
    SettlementType["ACTION_CODE"] = "ACTION_CODE";
    SettlementType["CALCULATION_ERROR"] = "CALCULATION_ERROR";
    SettlementType["CANCELLED_BY_CUSTOMER"] = "CANCELLED_BY_CUSTOMER";
    SettlementType["CANCELLED_BY_CUSTOMER_SUPPORT"] = "CANCELLED_BY_CUSTOMER_SUPPORT";
    SettlementType["COOL_BOX_OPEN"] = "COOL_BOX_OPEN";
    SettlementType["CORRECTION_PARTNERSHOP"] = "CORRECTION_PARTNERSHOP";
    SettlementType["DAMAGED"] = "DAMAGED";
    SettlementType["DAMAGE_CLEANING_COSTS"] = "DAMAGE_CLEANING_COSTS";
    SettlementType["DEFROSTED"] = "DEFROSTED";
    SettlementType["DELIVERY_TOO_EARLY"] = "DELIVERY_TOO_EARLY";
    SettlementType["DELIVERY_TOO_LATE"] = "DELIVERY_TOO_LATE";
    SettlementType["DEPOSITS_EXCEED_ORDER_VALUE"] = "DEPOSITS_EXCEED_ORDER_VALUE";
    SettlementType["DISCOUNT_NOT_APPLIED"] = "DISCOUNT_NOT_APPLIED";
    SettlementType["DOUBLE_PAYMENT"] = "DOUBLE_PAYMENT";
    SettlementType["EXPIRED"] = "EXPIRED";
    SettlementType["FROZEN"] = "FROZEN";
    SettlementType["GENERAL_COMPENSATION"] = "GENERAL_COMPENSATION";
    SettlementType["GENERAL_CORRECTION"] = "GENERAL_CORRECTION";
    SettlementType["LEAKY"] = "LEAKY";
    SettlementType["MISSING"] = "MISSING";
    SettlementType["MISSING_LOAD_CARRIER"] = "MISSING_LOAD_CARRIER";
    SettlementType["MOULDY"] = "MOULDY";
    SettlementType["NOT_AT_HOME"] = "NOT_AT_HOME";
    SettlementType["NOT_PICKED_UP"] = "NOT_PICKED_UP";
    SettlementType["NO_GEL_PACKS"] = "NO_GEL_PACKS";
    SettlementType["ONLINE_PRICE_DIFFERS"] = "ONLINE_PRICE_DIFFERS";
    SettlementType["OTHER"] = "OTHER";
    SettlementType["PACKAGING_DEPOSIT"] = "PACKAGING_DEPOSIT";
    SettlementType["PACKING_SLIP_PRICE_DIFFERS"] = "PACKING_SLIP_PRICE_DIFFERS";
    SettlementType["PARTIALLY_NOT_DELIVERED"] = "PARTIALLY_NOT_DELIVERED";
    SettlementType["PAST_EXPIRY_MARGIN"] = "PAST_EXPIRY_MARGIN";
    SettlementType["PERSONAL_DISCOUNT_NOT_APPLIED"] = "PERSONAL_DISCOUNT_NOT_APPLIED";
    SettlementType["PICKUP_ORDER_COSTS"] = "PICKUP_ORDER_COSTS";
    SettlementType["RETURN"] = "RETURN";
    SettlementType["SPOILED"] = "SPOILED";
    SettlementType["SUBSCRIPTION_RESTITUTION"] = "SUBSCRIPTION_RESTITUTION";
    SettlementType["WRONG_DELIVERY"] = "WRONG_DELIVERY";
})(SettlementType || (SettlementType = {}));
/**
 * Order in which the facade should return products.
 * This is sorted BEFORE splitting into pages
 */
export var SortBySort;
(function (SortBySort) {
    SortBySort["ASC_DATE"] = "ASC_DATE";
    SortBySort["ASC_DEPARTMENT"] = "ASC_DEPARTMENT";
    SortBySort["ASC_FREQUENCY"] = "ASC_FREQUENCY";
    SortBySort["ASC_RELEVANCE"] = "ASC_RELEVANCE";
    SortBySort["DESC_DATE"] = "DESC_DATE";
    SortBySort["DESC_DEPARTMENT"] = "DESC_DEPARTMENT";
    SortBySort["DESC_FREQUENCY"] = "DESC_FREQUENCY";
    SortBySort["DESC_RELEVANCE"] = "DESC_RELEVANCE";
})(SortBySort || (SortBySort = {}));
/** Error reason for Sharing link validation and stamp transfer failiure. */
export var StampShareErrorReason;
(function (StampShareErrorReason) {
    StampShareErrorReason["CANNOT_SELF_SHARE"] = "CANNOT_SELF_SHARE";
    StampShareErrorReason["LINK_CONSUMED"] = "LINK_CONSUMED";
    StampShareErrorReason["LINK_EXPIRED"] = "LINK_EXPIRED";
    StampShareErrorReason["LINK_NOT_FOUND"] = "LINK_NOT_FOUND";
    StampShareErrorReason["NOT_ENOUGH_STAMPS"] = "NOT_ENOUGH_STAMPS";
    StampShareErrorReason["SHARING_NOT_ALLOWED"] = "SHARING_NOT_ALLOWED";
    StampShareErrorReason["UNKNOWN"] = "UNKNOWN";
})(StampShareErrorReason || (StampShareErrorReason = {}));
/** The type of opening day */
export var StoresOpeningDayType;
(function (StoresOpeningDayType) {
    /** current */
    StoresOpeningDayType["CURRENT"] = "CURRENT";
    /** future */
    StoresOpeningDayType["FUTURE"] = "FUTURE";
    /** past */
    StoresOpeningDayType["PAST"] = "PAST";
})(StoresOpeningDayType || (StoresOpeningDayType = {}));
/** Time frames stores can be open */
export var StoresOpeningHourType;
(function (StoresOpeningHourType) {
    /** Store is open in evening */
    StoresOpeningHourType["EVENING"] = "EVENING";
    /** Store is open now */
    StoresOpeningHourType["NOW"] = "NOW";
    /** Store is open on sundays */
    StoresOpeningHourType["SUNDAY"] = "SUNDAY";
})(StoresOpeningHourType || (StoresOpeningHourType = {}));
/** The type of store */
export var StoresType;
(function (StoresType) {
    /** normal shop */
    StoresType["REGULAR"] = "REGULAR";
    /** ah togo */
    StoresType["TOGO"] = "TOGO";
    /** unknown */
    StoresType["UNKNOWN"] = "UNKNOWN";
    /** big xl shop */
    StoresType["XL"] = "XL";
})(StoresType || (StoresType = {}));
/** Possible payment status after payment */
export var SubscriptionPaymentStatus;
(function (SubscriptionPaymentStatus) {
    /** Payment has been cancelled */
    SubscriptionPaymentStatus["CANCELLED"] = "CANCELLED";
    /** Payment has been completed */
    SubscriptionPaymentStatus["COMPLETED"] = "COMPLETED";
    /** Payment has expired */
    SubscriptionPaymentStatus["EXPIRED"] = "EXPIRED";
    /** Payment has failed */
    SubscriptionPaymentStatus["FAILURE"] = "FAILURE";
    /** Payment is newly created */
    SubscriptionPaymentStatus["NEW"] = "NEW";
    /** Payment is open */
    SubscriptionPaymentStatus["OPEN"] = "OPEN";
})(SubscriptionPaymentStatus || (SubscriptionPaymentStatus = {}));
/** The type of the link: DEEPLINK, WEB */
export var SubscriptionSavingsCarouselLinkType;
(function (SubscriptionSavingsCarouselLinkType) {
    /** DEEPLINK */
    SubscriptionSavingsCarouselLinkType["DEEPLINK"] = "DEEPLINK";
    /** WEB */
    SubscriptionSavingsCarouselLinkType["WEB"] = "WEB";
})(SubscriptionSavingsCarouselLinkType || (SubscriptionSavingsCarouselLinkType = {}));
/** Themes for the premium savings carousel */
export var SubscriptionSavingsCarouselTheme;
(function (SubscriptionSavingsCarouselTheme) {
    /** BLUE */
    SubscriptionSavingsCarouselTheme["BLUE"] = "BLUE";
    /** GOLD */
    SubscriptionSavingsCarouselTheme["GOLD"] = "GOLD";
    /** ORANGE */
    SubscriptionSavingsCarouselTheme["ORANGE"] = "ORANGE";
})(SubscriptionSavingsCarouselTheme || (SubscriptionSavingsCarouselTheme = {}));
/** Currently supported subscriptionTypes */
export var SubscriptionType;
(function (SubscriptionType) {
    /** B2B delivery bundle */
    SubscriptionType["B2B"] = "B2B";
    /** B2C delivery bundle */
    SubscriptionType["BEZORG"] = "BEZORG";
    /** PREMIUM */
    SubscriptionType["OMNI"] = "OMNI";
})(SubscriptionType || (SubscriptionType = {}));
/**
 * An enumeration that contains the exact error reason that might be returned when attempting to
 * allocate a targeted offer to a member.
 */
export var TargetedOfferAllocationErrorReason;
(function (TargetedOfferAllocationErrorReason) {
    /**
     * A challenge answer was provided, but it was not the one expected for this member
     * (Belgium-only).
     */
    TargetedOfferAllocationErrorReason["CHALLENGE_MISMATCH"] = "CHALLENGE_MISMATCH";
    /**
     * Unable to allocate a targeted offer as the member does not have enough points to trade
     * in for an targeted offer.
     */
    TargetedOfferAllocationErrorReason["NOT_ENOUGH_POINTS"] = "NOT_ENOUGH_POINTS";
    /**
     * Unable to allocate a targeted offer as the member is not opted in for Digital Savings,
     * and thus does not have access to this feature.
     */
    TargetedOfferAllocationErrorReason["NOT_OPTED_IN"] = "NOT_OPTED_IN";
    /** No challenge answer was provided, but one was expected (Belgium-only). */
    TargetedOfferAllocationErrorReason["NO_CHALLENGE_PROVIDED"] = "NO_CHALLENGE_PROVIDED";
    /** Unable to allocate a targeted offer as there are none more available (for this member). */
    TargetedOfferAllocationErrorReason["NO_OFFER_AVAILABLE"] = "NO_OFFER_AVAILABLE";
    /** Unknown exception occurred, most likely due to a backend system malfunctioning. */
    TargetedOfferAllocationErrorReason["UNKNOWN"] = "UNKNOWN";
    /** A challenge answer was provided, but it was incorrect (Belgium-only). */
    TargetedOfferAllocationErrorReason["WRONG_CHALLENGE_ANSWER"] = "WRONG_CHALLENGE_ANSWER";
})(TargetedOfferAllocationErrorReason || (TargetedOfferAllocationErrorReason = {}));
/**
 * An enumeration containing the status of a targeted offer. This status indicates if and what
 * action a member has already taken for a particular targeted offer.
 */
export var TargetedOfferStatus;
(function (TargetedOfferStatus) {
    /**
     * The targeted offer is (still) redeemable. This means that the member is eligable to pick
     * up one or multiple of the products in the targeted offer.
     */
    TargetedOfferStatus["REDEEMABLE"] = "REDEEMABLE";
    /** The targeted offer has been redeemed, and can not be redeemed a second time. */
    TargetedOfferStatus["REDEEMED"] = "REDEEMED";
})(TargetedOfferStatus || (TargetedOfferStatus = {}));
/**
 * Image renditions returned by the product image processor
 * in the form of D<width>x<height>
 */
export var TaxonomyImageRenditions;
(function (TaxonomyImageRenditions) {
    /** width: 200, height: 200 */
    TaxonomyImageRenditions["D200X200"] = "D200X200";
    /** width: 400, height: 400 */
    TaxonomyImageRenditions["D400X400"] = "D400X400";
    /** width: 800, height: 800 */
    TaxonomyImageRenditions["D800X800"] = "D800X800";
})(TaxonomyImageRenditions || (TaxonomyImageRenditions = {}));
/** Transaction status enum */
export var TransactionStatus;
(function (TransactionStatus) {
    /** The transaction is cancelled */
    TransactionStatus["CANCELLED"] = "CANCELLED";
    /** The transaction is completed */
    TransactionStatus["COMPLETED"] = "COMPLETED";
    /** The transaction is refunded */
    TransactionStatus["REFUNDED"] = "REFUNDED";
    /** The transaction is reserved */
    TransactionStatus["RESERVED"] = "RESERVED";
})(TransactionStatus || (TransactionStatus = {}));
/** Type that defines type of the transaction */
export var TransactionType;
(function (TransactionType) {
    TransactionType["CREDIT"] = "CREDIT";
    TransactionType["DEBIT"] = "DEBIT";
})(TransactionType || (TransactionType = {}));
/** A block unsubscribe reason */
export var UnsubscribeBlockerReason;
(function (UnsubscribeBlockerReason) {
    /** There is still a active B2B delivery bundle */
    UnsubscribeBlockerReason["ACTIVE_B2B_DELIVERY_BUNDLE"] = "ACTIVE_B2B_DELIVERY_BUNDLE";
    /** There is still a active delivery bundle */
    UnsubscribeBlockerReason["ACTIVE_DELIVERY_BUNDLE"] = "ACTIVE_DELIVERY_BUNDLE";
    /** There is still a active or cancelled premium subscription */
    UnsubscribeBlockerReason["ACTIVE_OR_CANCELLED_PREMIUM_SUBSCRIPTION"] = "ACTIVE_OR_CANCELLED_PREMIUM_SUBSCRIPTION";
    /** There is still a active premium subscription */
    UnsubscribeBlockerReason["ACTIVE_PREMIUM_SUBSCRIPTION"] = "ACTIVE_PREMIUM_SUBSCRIPTION";
    /** There is still an open settlement for the customer */
    UnsubscribeBlockerReason["OPEN_SETTLEMENT"] = "OPEN_SETTLEMENT";
    /** There is still a positive balance of purchase stamps */
    UnsubscribeBlockerReason["POSITIVE_PURCHASE_STAMP_BALANCE"] = "POSITIVE_PURCHASE_STAMP_BALANCE";
})(UnsubscribeBlockerReason || (UnsubscribeBlockerReason = {}));
/** Specific error code when card has been updated */
export var UpdateCardResultCode;
(function (UpdateCardResultCode) {
    /** Card can not be deleted as it has a pending reservation */
    UpdateCardResultCode["CARD_HAS_PENDING_RESERVATION"] = "CARD_HAS_PENDING_RESERVATION";
    /** Unknown error has occurred. */
    UpdateCardResultCode["UNKNOWN"] = "UNKNOWN";
})(UpdateCardResultCode || (UpdateCardResultCode = {}));
export var WeekDay;
(function (WeekDay) {
    WeekDay["FRIDAY"] = "FRIDAY";
    WeekDay["MONDAY"] = "MONDAY";
    WeekDay["SATURDAY"] = "SATURDAY";
    WeekDay["SUNDAY"] = "SUNDAY";
    WeekDay["THURSDAY"] = "THURSDAY";
    WeekDay["TUESDAY"] = "TUESDAY";
    WeekDay["WEDNESDAY"] = "WEDNESDAY";
})(WeekDay || (WeekDay = {}));
